import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Alert,
  Collapse,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import Select from 'react-select';
import qs from 'qs';
import { FaChevronDown, FaChevronUp, FaPencilAlt, FaPlus, FaTrash } from 'react-icons/fa';
import { CondicoesEspeciaisStatus, TipoComissao } from '~/constant';
import { buscarSimulacaoFinanciamento, buscarCartoesSimulador, buscarPropostaAuxiliar, getGerentes, BuscarCorretoresUsuarios, gerarPropostaSimuladorPdf, pegarValoresAlcadas } from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import ModalDivisaoComissao from '~/Components/Vendas/ModalDivisaoComissao';
import { customStylesSm, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { calcularValorFuturo } from '~/Pages/Vendas/helpers';
import {
  calcularValorParcelaPRICE,
  calcularQtdParcelasPRICE,
  calcularEntradaPRICE,
  calcularQtdParcelasSAC,
  gerarTabelaSAC,
  gerarTabelaPRICE,
  gerarTabelaAntecipacao,
  gerarTabelaAntecipacaoUnificada,
  calcularResumoAntecipacao,
  calcularResumoAntecipacaoPorValor,
  calcularResumoAntecipacaoUnificado,
  calcularResumoAntecipacaoUnificadoPorValor,
  calcularValorPresente,
  ajustarRestoQtdParcelas,
} from './calculos';
import moment from 'moment';
import { formatCurrency, formatDate } from './utils';
import { validarPayloadAntesAbrirModal, calcularVencimentoFinanciamentoDefault, calcularVencimentoMinimoCarencia, simulatorStateToPropostaPayload } from './payload';
import {
  ResumoAtivo,
  FormularioSimulacao,
  ResultadoSimulacao,
  TabelaSAC,
  PainelAntecipacao,
  AvisoIndisponivel,
  SelecaoAtivo,
  ParcelasCondicionantes,
  ParcelasIntermediariasManual,
  ResumoVenda,
  PagamentosSinalSplit,
  CondicoesEspeciaisCompleto,
  ModalGerarVenda,
} from './components';

const DIAS_VENCIMENTO_PROGRAMADAS = [5, 10, 15, 20, 25];
const MENSAGEM_PROGRAMADAS_COM_CARENCIA = 'Não é possível seguir com a inclusão de Parcelas Programadas. '
  + 'É preciso remover a condição especial de carência para incluí-las.';
const VALORES_ALCADA_INICIAIS = {
  percentual_corretor: 0,
  meses_corretor: 0,
  percentual_gerente: 0,
  meses_gerente: 0,
};

const normalizarNumero = valor => {
  const numero = Number(valor);
  return isNaN(numero) ? 0 : numero;
};

function condicaoPossuiCarencia(condicoes) {
  return !!(
    condicoes &&
    condicoes.financiamento &&
    condicoes.financiamento.isAtivo &&
    Number(condicoes.financiamento.meses || 0) > 0
  );
}

const normalizarValoresAlcada = valores => {
  if (!valores) return VALORES_ALCADA_INICIAIS;
  return {
    percentual_corretor: normalizarNumero(valores.percentual_corretor || valores.Percentual_Corretor),
    meses_corretor: normalizarNumero(valores.meses_corretor || valores.Meses_Corretor),
    percentual_gerente: normalizarNumero(valores.percentual_gerente || valores.Percentual_Gerente),
    meses_gerente: normalizarNumero(valores.meses_gerente || valores.Meses_Gerente),
  };
};

const calcularAlcadaCondicaoEspecial = (condicoes, valoresAlcada) => {
  const alcadas = normalizarValoresAlcada(valoresAlcada);
  const descontoLote = condicoes.valorLote && condicoes.valorLote.isAtivo
    ? normalizarNumero(condicoes.valorLote.porcentagem)
    : 0;
  const mesesFinanciamento = condicoes.financiamento && condicoes.financiamento.isAtivo
    ? normalizarNumero(condicoes.financiamento.meses)
    : 0;
  const valorSaldoCorrecao = condicoes.saldoCorrecao && condicoes.saldoCorrecao.isAtivo
    ? normalizarNumero(condicoes.saldoCorrecao.valor)
    : 0;
  const temTravaDiretoria = !!condicoes.isIsencao || valorSaldoCorrecao > 0;

  if (
    temTravaDiretoria ||
    descontoLote > alcadas.percentual_gerente ||
    mesesFinanciamento > alcadas.meses_gerente
  ) {
    return {
      status: CondicoesEspeciaisStatus.PendenteDiretoria,
      travarVenda: { travarCorretor: true, travarGerente: true },
      avisoAlcada: 'Será criada uma solicitação de aprovação para a Diretoria.',
    };
  }

  if (
    descontoLote > alcadas.percentual_corretor ||
    mesesFinanciamento > alcadas.meses_corretor
  ) {
    return {
      status: CondicoesEspeciaisStatus.PendenteGerente,
      travarVenda: { travarCorretor: true, travarGerente: false },
      avisoAlcada: 'Será criada uma solicitação de aprovação para o gerente.',
    };
  }

  return {
    status: CondicoesEspeciaisStatus.SolicitacaoAprovada,
    travarVenda: { travarCorretor: false, travarGerente: false },
    avisoAlcada: 'Condição dentro da alçada configurada para o corretor.',
  };
};

const calcularVencimentoEscadinha = (dataBase, mesOffset, diaVencimento) => {
  const dataBaseIso = typeof dataBase === 'string'
    ? dataBase
    : moment(dataBase).format('YYYY-MM-DD');
  const [ano, mes] = dataBaseIso.split('-').map(Number);
  // Opera como índice de meses (0-based) para evitar problema de timezone
  // com Date.toISOString() quando se usam métodos locais.
  const totalMeses = (ano - 1) * 12 + (mes - 1) + mesOffset;
  const novoAno = Math.floor(totalMeses / 12) + 1;
  const novoMes = (totalMeses % 12) + 1;
  return `${novoAno}-${String(novoMes).padStart(2, '0')}-${String(diaVencimento).padStart(2, '0')}`;
};

// Gera as séries da escadinha usando configuração do Ativo_Escadinha (mesmo padrão
// da venda real em Components/Vendas/Financiamento/index.js:603-651):
//   - valor 1ª série = escadinha.parcela_inicial (vem do cadastro do lote, em R$)
//   - cada série soma `degrau` no valor anterior
//   - vencimentos começam no mês seguinte ao último sinal e seguem mês a mês
//
// W-0075 (devolução): desconta da 1ª série os meses ocupados pelo sinal depois da primeira parcela.
// O valor presente dessas parcelas omitidas reaparece no financiamento automaticamente,
// porque totalEscadinhaVP fica menor e saldoFinanciarLiquido aumenta.
const gerarSeriesEscadinha = (escadinha, dataBase, taxa, qtdParcelasSinalAposPrimeira, ultimoVencimentoSinal, diaVencimento) => {
  const { quantidade_de_series, parcelas_por_serie, degrau } = escadinha;
  const valorInicial = escadinha.parcela_inicial || 0;
  const mesesAteUltimoSinal = ultimoVencimentoSinal
    ? Math.max(0, Math.round(moment(ultimoVencimentoSinal).diff(moment(dataBase), 'months', true)))
    : 0;
  const parcelasSinalAposPrimeira = Math.max(0, qtdParcelasSinalAposPrimeira || 0);
  const descontoSinal = ultimoVencimentoSinal
    ? Math.max(mesesAteUltimoSinal, parcelasSinalAposPrimeira)
    : parcelasSinalAposPrimeira;
  const dataInicio = ultimoVencimentoSinal || dataBase;
  const dia = DIAS_VENCIMENTO_PROGRAMADAS.includes(Number(diaVencimento))
    ? Number(diaVencimento)
    : 10;
  const resultado = [];
  let mesOffset = 1;
  for (let serie = 0; serie < quantidade_de_series; serie++) {
    const valorSerie = Math.round((valorInicial + serie * degrau) * 100) / 100;
    const parcelasDessaSerie =
      serie === 0
        ? Math.max(0, parcelas_por_serie - descontoSinal)
        : parcelas_por_serie;
    for (let i = 0; i < parcelasDessaSerie; i++) {
      const n = mesOffset;
      const vf = valorSerie;
      const vencimento = calcularVencimentoEscadinha(dataInicio, n, dia);
      const mesesValorPresente = Math.max(
        0,
        moment(vencimento).diff(moment(dataBase), 'days') / 30
      );
      const vp = taxa > 0
        ? Math.round(vf / Math.pow(1 + taxa, mesesValorPresente) * 100) / 100
        : vf;
      resultado.push({
        valor_presente: vp,
        valor: vf,
        vencimento,
        parcela: resultado.length + 1,
        tipo_escadinha: true,
        tipo_parcela: 1,
        tipo_parcela_financiamento: 'Programada',
        periodicidade_balao: null,
      });
      mesOffset++;
    }
  }
  return resultado;
};

const arredondarMoeda = (valor) => Math.round(Math.max(valor || 0, 0) * 100) / 100;

const calcularValorFuturoEscadinhaBackend = (valorPresente, taxaDecimal, dataBase, dataProjetada) => {
  const diffDias = Math.ceil(
    moment(dataProjetada).startOf('day').diff(moment(dataBase).startOf('day'), 'days', true)
  );
  return valorPresente * Math.pow(1 + taxaDecimal, (diffDias + 1) / 30.0);
};

const obterDataUltimaParcela = (parcelas) => {
  const vencimentos = (parcelas || [])
    .map((p) => p && p.vencimento)
    .filter(Boolean)
    .sort();
  return vencimentos.length ? vencimentos[vencimentos.length - 1] : null;
};

const projetarSaldoFinanciamento = (
  saldo,
  taxaDecimal,
  dataBase,
  parcelasEmSeries,
  vencimentoFinanciamento,
  parcelasIntermediarias,
  isParcelasNaoConcomitantes
) => {
  let saldoProjetado = saldo || 0;
  if (parcelasEmSeries && parcelasEmSeries.length > 0) {
    const dataProjetadaProgramadas = vencimentoFinanciamento
      ? moment(vencimentoFinanciamento).subtract(1, 'month')
      : moment(obterDataUltimaParcela(parcelasEmSeries));
    if (dataProjetadaProgramadas.isValid()) {
      saldoProjetado = calcularValorFuturoEscadinhaBackend(
        saldoProjetado,
        taxaDecimal,
        dataBase,
        dataProjetadaProgramadas
      );
    }
  }

  if (isParcelasNaoConcomitantes && parcelasIntermediarias && parcelasIntermediarias.length > 0) {
    const ultimoVencimentoIntermediaria = obterDataUltimaParcela(parcelasIntermediarias);
    if (ultimoVencimentoIntermediaria) {
      saldoProjetado = calcularValorFuturoEscadinhaBackend(
        saldoProjetado,
        taxaDecimal,
        dataBase,
        ultimoVencimentoIntermediaria
      );
    }
  }

  return arredondarMoeda(saldoProjetado);
};

function pickCampo(obj, chaves, fallback) {
  if (!obj) return fallback;
  for (var i = 0; i < chaves.length; i++) {
    var chave = chaves[i];
    if (obj[chave] !== undefined && obj[chave] !== null) return obj[chave];
  }
  return fallback;
}

function normalizarDataInput(valor) {
  if (!valor) return '';
  var m = moment(valor);
  if (!m.isValid()) return '';
  return m.format('YYYY-MM-DD');
}

function normalizarDataMesAno(valor) {
  if (!valor) return '';
  var m = moment(valor);
  if (!m.isValid()) return '';
  return m.format('MM/YYYY');
}

function normalizarStatusCondicao(status) {
  if (status === undefined || status === null || status === '') return null;
  if (typeof status === 'number') return status;
  var texto = String(status).toLowerCase();
  if (texto === 'contraproposta' || texto === 'contra_proposta') return CondicoesEspeciaisStatus.Contraproposta;
  if (texto === 'pendentegerente' || texto === 'pendente_gerente') return CondicoesEspeciaisStatus.PendenteGerente;
  if (texto === 'pendentediretoria' || texto === 'pendente_diretoria') return CondicoesEspeciaisStatus.PendenteDiretoria;
  if (texto === 'solicitacaoaprovada' || texto === 'solicitacao_aprovada') return CondicoesEspeciaisStatus.SolicitacaoAprovada;
  var numero = parseInt(status, 10);
  return isNaN(numero) ? null : numero;
}

function avisoAlcadaSolicitacaoExistente(status) {
  if (status === CondicoesEspeciaisStatus.PendenteGerente) {
    return 'Solicitação aguardando aprovação do gerente.';
  }
  if (status === CondicoesEspeciaisStatus.PendenteDiretoria) {
    return 'Solicitação aguardando aprovação da Diretoria.';
  }
  if (status === CondicoesEspeciaisStatus.Contraproposta) {
    return 'Contraproposta aguardando análise.';
  }
  if (status === CondicoesEspeciaisStatus.SolicitacaoAprovada) {
    return 'Solicitação de condição especial aprovada.';
  }
  return null;
}

function mapPagamentoProposta(parcela) {
  var tipoParcela = pickCampo(parcela, ['tipo_parcela', 'tipoParcela'], null);
  var cheque = pickCampo(parcela, ['cheque', 'Cheque'], null);
  var cartao = pickCampo(parcela, ['cartao', 'Cartao'], null);
  var resultado = Object.assign({}, parcela, cheque || {}, {
    tipo_parcela: tipoParcela,
    valor: normalizarNumero(pickCampo(parcela, ['valor', 'Valor'], 0)),
    vencimento: normalizarDataInput(pickCampo(parcela, ['vencimento', 'Vencimento'], '')),
  });

  if (cartao) {
    resultado.cartao = {
      codigo: pickCampo(cartao, ['codigo', 'Codigo'], null),
      numero_documento: pickCampo(cartao, ['numero_documento', 'numeroDocumento', 'NumeroDocumento'], ''),
    };
    resultado.numero_documento = resultado.cartao.numero_documento;
  }

  return resultado;
}

function mapCondicoesProposta(condicoes, valoresAlcada) {
  if (!condicoes) return null;

  var financiamento = pickCampo(condicoes, ['financiamento', 'Financiamento'], {});
  var saldoCorrecao = pickCampo(condicoes, ['saldo_correcao', 'saldoCorrecao', 'SaldoCorrecao'], {});
  var valorLote = pickCampo(condicoes, ['valor_lote', 'valorLote', 'ValorLote'], {});
  var prazoFinanciamento = normalizarNumero(pickCampo(financiamento, ['prazo_financiamento_meses', 'prazoFinanciamentoMeses', 'PrazoFinanciamentoMeses'], 0));
  var valorSaldoCorrecao = normalizarNumero(pickCampo(saldoCorrecao, ['valor_saldo_correcao', 'valorSaldoCorrecao', 'ValorSaldoCorrecao'], 0));
  var valorSugerido = normalizarNumero(pickCampo(valorLote, ['valor_sugerido', 'valorSugerido', 'ValorSugerido'], 0));
  var porcentagemDesconto = normalizarNumero(pickCampo(valorLote, ['porcentagem_desconto', 'porcentagemDesconto', 'PorcentagemDesconto', 'porcentagem', 'Porcentagem'], 0));
  var descricao = pickCampo(condicoes, ['descricao', 'Descricao'], '') || '';
  var isIsencao = !!pickCampo(condicoes, ['is_isencao', 'isIsencao'], false);

  if (!descricao && !isIsencao && prazoFinanciamento <= 0 && valorSaldoCorrecao <= 0 && valorSugerido <= 0 && porcentagemDesconto <= 0) {
    return null;
  }

  var local = {
    isIsencao: isIsencao,
    financiamento: {
      isAtivo: prazoFinanciamento > 0,
      meses: prazoFinanciamento,
      dataPrazo: normalizarDataInput(pickCampo(financiamento, ['data_prazo_financiamento', 'dataPrazoFinanciamento', 'DataPrazoFinanciamento'], '')),
    },
    saldoCorrecao: {
      isAtivo: valorSaldoCorrecao > 0,
      valor: valorSaldoCorrecao,
      data: normalizarDataMesAno(pickCampo(saldoCorrecao, ['data_saldo', 'dataSaldo', 'DataSaldo'], '')),
    },
    valorLote: {
      isAtivo: valorSugerido > 0 || porcentagemDesconto > 0,
      valorSugerido: valorSugerido,
      porcentagem: porcentagemDesconto,
    },
    descricao: descricao,
  };

  var alcada = calcularAlcadaCondicaoEspecial(local, valoresAlcada);
  var status = normalizarStatusCondicao(pickCampo(condicoes, ['status', 'Status'], null));
  var avisoSolicitacaoExistente = avisoAlcadaSolicitacaoExistente(status);
  return Object.assign({}, local, alcada, {
    status: status || alcada.status,
    avisoAlcada: avisoSolicitacaoExistente || alcada.avisoAlcada,
  });
}

function mapParcelasIntermediariasProposta(parcelas) {
  return (parcelas || []).map(function(item, index) {
    return {
      id: 'prop-inter-' + index + '-' + normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
      tipo: 'Intermediária',
      valorPresente: normalizarNumero(pickCampo(item, ['valor_presente', 'valorPresente', 'ValorPresente'], 0)),
      valorFuturo: normalizarNumero(pickCampo(item, ['valor', 'Valor'], 0)),
      vencimento: normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
    };
  });
}

function mapCondicionantesProposta(parcelas) {
  return (parcelas || []).map(function(item, index) {
    var periodicidade = pickCampo(item, ['periodicidade_balao', 'periodicidadeBalao', 'PeriodicidadeBalao'], null);
    var tipo = String(periodicidade) === '1' ? 'Construção' : 'Adimplência';
    return {
      id: 'prop-cond-' + index + '-' + normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
      tipo: tipo,
      percentual: normalizarNumero(pickCampo(item, ['percentual', 'Percentual'], 0)),
      valorPresente: normalizarNumero(pickCampo(item, ['valor_presente', 'valorPresente', 'ValorPresente'], 0)),
      valorFuturo: normalizarNumero(pickCampo(item, ['valor', 'Valor'], 0)),
      vencimento: normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
      codigoIntermediaria: pickCampo(item, ['codigo_intermediaria', 'codigo_intermediarias', 'codigoIntermediaria', 'CodigoIntermediaria', 'CodigoIntermediarias'], null),
    };
  });
}

function mapParcelasProgramadasProposta(parcelas) {
  return (parcelas || []).map(function(item, index) {
    return {
      id: 'prop-prog-' + index + '-' + normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
      valor_presente: normalizarNumero(pickCampo(item, ['valor_presente', 'valorPresente', 'ValorPresente'], 0)),
      valor: normalizarNumero(pickCampo(item, ['valor', 'Valor'], 0)),
      vencimento: normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
      parcela: pickCampo(item, ['parcela', 'Parcela'], index + 1),
      tipo_escadinha: true,
      tipo_parcela: 1,
      tipo_parcela_financiamento: 'Programada',
      periodicidade_balao: null,
    };
  });
}

function normalizarCondicaoComparacao(condicoes) {
  if (!condicoes) return null;
  return {
    isIsencao: !!condicoes.isIsencao,
    financiamentoMeses: condicoes.financiamento ? normalizarNumero(condicoes.financiamento.meses) : 0,
    saldoValor: condicoes.saldoCorrecao ? normalizarNumero(condicoes.saldoCorrecao.valor) : 0,
    saldoData: condicoes.saldoCorrecao ? (condicoes.saldoCorrecao.data || '') : '',
    valorSugerido: condicoes.valorLote ? normalizarNumero(condicoes.valorLote.valorSugerido) : 0,
    porcentagem: condicoes.valorLote ? normalizarNumero(condicoes.valorLote.porcentagem) : 0,
    descricao: condicoes.descricao || '',
  };
}

function atualizarValorLoteCondicao(condicoes, valorVendaOriginal, novoValorVenda) {
  if (!condicoes) return condicoes;
  if (!condicoes.valorLote || !condicoes.valorLote.isAtivo) {
    return Object.assign({}, condicoes);
  }

  var valorOriginal = normalizarNumero(valorVendaOriginal);
  var valorNovo = normalizarNumero(novoValorVenda);
  var porcentagem = valorOriginal > 0
    ? parseFloat(((Math.abs(valorOriginal - valorNovo) / valorOriginal) * 100).toFixed(3))
    : normalizarNumero(condicoes.valorLote.porcentagem);

  return Object.assign({}, condicoes, {
    valorLote: Object.assign({}, condicoes.valorLote, {
      valorSugerido: valorNovo,
      porcentagem: porcentagem,
    }),
  });
}

function obterValorVendaPropostaComCondicao(valorAtivoProposta, condicoes, valorVendaOriginal) {
  var valorAtivo = normalizarNumero(valorAtivoProposta);
  if (condicoes && condicoes.valorLote && condicoes.valorLote.isAtivo) {
    var valorSugerido = normalizarNumero(condicoes.valorLote.valorSugerido);
    if (valorSugerido > 0) return valorSugerido;

    var porcentagem = normalizarNumero(condicoes.valorLote.porcentagem);
    var valorOriginal = normalizarNumero(valorVendaOriginal);
    if (porcentagem > 0 && valorOriginal > 0) {
      return Math.round((valorOriginal - (valorOriginal * porcentagem / 100)) * 100) / 100;
    }
  }
  return valorAtivo > 0 ? valorAtivo : normalizarNumero(valorVendaOriginal);
}

function normalizarFinanciamentoComparacao(financiamento, vencimento) {
  if (!financiamento) return null;
  return {
    qtd: normalizarNumero(financiamento.qtd),
    valorParcela: normalizarNumero(financiamento.valorParcela),
    vencimento: normalizarDataInput(vencimento),
  };
}

function criarPlanoSelecionadoProposta(financiamento, dados) {
  if (!financiamento) return null;
  var qtd = normalizarNumero(financiamento.qtd);
  var planos = (dados && dados.planos) || [];
  var plano = planos.find(function(p) {
    return normalizarNumero(p.plano) === qtd;
  });

  if (plano) {
    return {
      value: plano.plano,
      label: plano.plano === 0 ? 'À Vista' : plano.plano + 'x',
      plano: plano,
    };
  }

  if (qtd === 0) {
    return { value: 0, label: 'À Vista', plano: { plano: 0 } };
  }

  return {
    value: 'proposta-' + qtd,
    label: qtd + 'x (proposta gravada)',
    plano: { plano: qtd },
  };
}

function compararJson(valor) {
  return JSON.stringify(valor || null);
}

function normalizarListaComparacao(lista, mapper) {
  return (lista || [])
    .map(mapper)
    .filter(Boolean)
    .sort(function(a, b) {
      return compararJson(a).localeCompare(compararJson(b));
    });
}

function normalizarPagamentoComparacao(item) {
  if (!item) return null;
  var cartao = item.cartao && typeof item.cartao === 'object' ? item.cartao : {};
  return {
    tipo: normalizarNumero(pickCampo(item, ['tipo_parcela', 'tipoParcela', 'TipoParcela'], 0)),
    valor: normalizarNumero(pickCampo(item, ['valor', 'Valor'], 0)),
    vencimento: normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
    banco: pickCampo(item, ['banco', 'Banco'], '') || '',
    agencia: pickCampo(item, ['agencia', 'Agencia'], '') || '',
    conta: pickCampo(item, ['conta', 'Conta'], '') || '',
    numero: pickCampo(item, ['numero', 'Numero'], '') || '',
    digitoBanco: pickCampo(item, ['digito_banco', 'digitoBanco', 'DigitoBanco'], '') || '',
    digitoAgencia: pickCampo(item, ['digito_agencia', 'digitoAgencia', 'DigitoAgencia'], '') || '',
    digitoConta: pickCampo(item, ['digito_conta', 'digitoConta', 'DigitoConta'], '') || '',
    emitente: pickCampo(item, ['emitente', 'Emitente'], '') || '',
    cgccpf: pickCampo(item, ['cgccpf', 'cgc_cpf', 'cgcCpf', 'CgcCpf'], '') || '',
    cartao: cartao.codigo || (item.cartao && typeof item.cartao !== 'object' ? item.cartao : null) || null,
    numeroDocumento: cartao.numero_documento || cartao.numeroDocumento || pickCampo(item, ['numero_documento', 'numeroDocumento'], '') || '',
  };
}

function normalizarCondicionanteComparacao(item) {
  if (!item) return null;
  return {
    tipo: item.tipo || '',
    percentual: normalizarNumero(item.percentual),
    valorPresente: normalizarNumero(item.valorPresente),
    valorFuturo: normalizarNumero(item.valorFuturo),
    vencimento: normalizarDataInput(item.vencimento),
    codigoIntermediaria: item.codigoIntermediaria || null,
  };
}

function normalizarIntermediariaComparacao(item) {
  if (!item) return null;
  return {
    valorPresente: normalizarNumero(item.valorPresente),
    valorFuturo: normalizarNumero(item.valorFuturo),
    vencimento: normalizarDataInput(item.vencimento),
  };
}

function normalizarProgramadaComparacao(item) {
  if (!item) return null;
  return {
    valorPresente: normalizarNumero(pickCampo(item, ['valor_presente', 'valorPresente'], 0)),
    valor: normalizarNumero(pickCampo(item, ['valor', 'Valor'], 0)),
    vencimento: normalizarDataInput(pickCampo(item, ['vencimento', 'Vencimento'], '')),
    parcela: pickCampo(item, ['parcela', 'Parcela'], null),
  };
}

function normalizarFluxoContraproposta(state) {
  return {
    sinalIncorp: normalizarListaComparacao(state.pagamentosIncorp || [], normalizarPagamentoComparacao),
    sinalMesa: normalizarListaComparacao(state.pagamentosMesa || [], normalizarPagamentoComparacao),
    condicionantes: normalizarListaComparacao(state.condicionantesAplicadas || [], normalizarCondicionanteComparacao),
    intermediarias: normalizarListaComparacao(state.parcelasIntermediariasManuais || [], normalizarIntermediariaComparacao),
    programadas: normalizarListaComparacao(state.parcelasEmSeries || [], normalizarProgramadaComparacao),
  };
}

function normalizarDivisaoComissaoComparacao(divisao) {
  if (!divisao || !divisao.codigoUsuario) {
    return { codigoUsuario: null, porcentagem: 0 };
  }
  return {
    codigoUsuario: String(divisao.codigoUsuario),
    porcentagem: normalizarNumero(divisao.porcentagem),
  };
}

function normalizarVendaContraproposta(state) {
  return {
    valorVenda: normalizarNumero(state.valorVendaEditado),
    dataBase: normalizarDataInput(state.dataBase),
    tabelaSelecionada: state.tabelaSelecionada ? String(state.tabelaSelecionada.value) : null,
    parcelasNaoConcomitantes: !!state.isParcelasNaoConcomitantes,
    divisaoComissao: normalizarDivisaoComissaoComparacao(state.divisaoComissao),
  };
}

function ConteudoSimulador(props) {
  var codigoProposta = props.codigoProposta || null;
  var [codigoAtivoContraproposta, setCodigoAtivoContraproposta] = useState(null);
  var [contextoContraproposta, setContextoContraproposta] = useState(null);
  var [propostaAuxiliar, setPropostaAuxiliar] = useState(null);
  var [carregandoProposta, setCarregandoProposta] = useState(false);
  var [erroProposta, setErroProposta] = useState(null);
  var [propostaOriginalSnapshot, setPropostaOriginalSnapshot] = useState(null);
  var [propostaHidratada, setPropostaHidratada] = useState(null);
  var [propostaAlteradaPeloUsuario, setPropostaAlteradaPeloUsuario] = useState(false);
  var codigoAtivo = props.codigoAtivo || codigoAtivoContraproposta;
  var contextoSelecao = props.contextoSelecao || contextoContraproposta || null;
  var onVendaGravadaFechar = props.onVendaGravadaFechar || function() {};

  var [dados, setDados] = useState(null);
  var [isLoading, setIsLoading] = useState(false);
  var [showModalGerarVenda, setShowModalGerarVenda] = useState(false);
  // Erros de validação da página (preenchidos pelo botão "Gerar Venda" antes de abrir o modal)
  var [errosPagina, setErrosPagina] = useState([]);

  var [tabelaSelecionada, setTabelaSelecionada] = useState(null);

  // --- Valores editáveis ---
  var [valorVendaEditado, setValorVendaEditado] = useState(0);
  var [dataBase, setDataBase] = useState(function() {
    return new Date().toISOString().substr(0, 10);
  });

  // --- Plano selecionado ---
  var [planoSelecionado, setPlanoSelecionado] = useState(null);

  // --- Simulação inversa ---
  var [modoSimulacao, setModoSimulacao] = useState('V');
  var [entradaCliente, setEntradaCliente] = useState('');
  var [qtdParcelas, setQtdParcelas] = useState('');
  var [valorParcela, setValorParcela] = useState('');
  var [mostrarSimulacaoInversa, setMostrarSimulacaoInversa] = useState(false);

  // --- Resultados ---
  var [resultado, setResultado] = useState(null);
  var [tabelaAmortizacao, setTabelaAmortizacao] = useState(null);
  var [antecipacao, setAntecipacao] = useState(null);
  // Resultado da última simulação de antecipação (qtd + direção) — drive os 3 boxes
  // coloridos do PainelAntecipacao e o highlight de linhas selecionadas na tabela.
  var [resultadoAntecipacao, setResultadoAntecipacao] = useState(null);

  // Reset signal — incrementa toda vez que o pai zera state grande (VV, CE, carregamento).
  // Filhos com estado local (ParcelasCondicionantes, CondicoesEspeciaisCompleto,
  // ParcelasIntermediariasManual) observam via useEffect e limpam o próprio estado,
  // evitando "fantasma" (visualmente marcado mas linhas zeradas no pai).
  var [resetCounter, setResetCounter] = useState(0);
  var bumpReset = useCallback(function() {
    setResetCounter(function(v) { return v + 1; });
  }, []);

  // --- Corretor ativo (W-0075) ---
  // Quem assina a venda. Corretor logado → auto-select e readonly.
  // ADM com característica 673 → escolhe da lista. Outros → não geram venda.
  const [corretorAtivo, setCorretorAtivo] = useState(null);
  const [opcoesCorretores, setOpcoesCorretores] = useState([]);

  const usuarioEhCorretor = useMemo(() => AuthStorage.isCorretor(), []);
  const podeEscolherCorretor = useMemo(
    () => AuthStorage.isADM() && AuthStorage.temCaracteristica(673),
    []
  );
  const podeGerarVenda = usuarioEhCorretor || podeEscolherCorretor;
  const modoCorretor = usuarioEhCorretor
    ? 'readonly'
    : (podeEscolherCorretor ? 'editavel' : 'oculto');
  var isModoProposta = !!codigoProposta;

  // Corretor logado vira o ator automaticamente. Pega o code do JWT (AuthStorage.getUser()).
  useEffect(() => {
    if (!usuarioEhCorretor) return;
    const user = AuthStorage.getUser();
    if (!user) return;
    const codigo = user.usuario || user.codigo_usuario || user.codigo;
    if (codigo) {
      setCorretorAtivo(codigo);
      setOpcoesCorretores([{ codigo, descricao: user.nome || user.login || ('Corretor ' + codigo) }]);
    }
  }, [usuarioEhCorretor]);

  // ADM com característica 673 carrega lista de corretores pra escolher.
  useEffect(() => {
    if (!podeEscolherCorretor) return;
    BuscarCorretoresUsuarios()
      .then((lista) => setOpcoesCorretores(Array.isArray(lista) ? lista : []))
      .catch(() => setOpcoesCorretores([]));
  }, [podeEscolherCorretor]);

  useEffect(function() {
    if (!codigoProposta) return;

    var ativo = true;
    setCarregandoProposta(true);
    setErroProposta(null);
    setPropostaAuxiliar(null);
    setPropostaHidratada(null);
    setPropostaOriginalSnapshot(null);
    setPropostaAlteradaPeloUsuario(false);

    buscarPropostaAuxiliar(codigoProposta)
      .then(function(response) {
        if (!ativo) return;
        var gravada = response && response.proposta_gravada;
        var inicial = response && response.proposta_inicial;
        var ativoGravado = gravada && gravada.ativos && gravada.ativos.length > 0
          ? gravada.ativos[0]
          : null;
        var empreendimento = inicial && inicial.empreendimento ? inicial.empreendimento : {};
        var codigoFamiliaProposta = pickCampo(gravada, ['codigo_familia', 'codigoFamilia'], null)
          || pickCampo(empreendimento, ['codigo', 'Codigo'], null);
        var codigoAtivoProposta = ativoGravado ? pickCampo(ativoGravado, ['codigo', 'Codigo'], null) : null;

        if (!gravada || !inicial || !codigoFamiliaProposta || !codigoAtivoProposta) {
          throw new Error('Proposta auxiliar incompleta para carregar no simulador.');
        }

        var prospectoCodigo = pickCampo(gravada, ['codigo_prospecto', 'codigoProspecto'], null)
          || pickCampo(inicial, ['codigo_prospecto', 'codigoProspecto'], null);
        setPropostaAuxiliar({
          response: response,
          gravada: gravada,
          inicial: inicial,
          ativo: ativoGravado,
        });
        setCodigoAtivoContraproposta(codigoAtivoProposta);
        setContextoContraproposta({
          codigoFamilia: codigoFamiliaProposta,
          empreendimentoLabel: codigoFamiliaProposta + ' - ' + (
            pickCampo(empreendimento, ['descricao', 'Descricao', 'nome', 'Nome'], '') || ''
          ),
          quadra: pickCampo(ativoGravado, ['quadra', 'Quadra', 'mapa1', 'Mapa1'], ''),
          lote: pickCampo(ativoGravado, ['lote', 'Lote', 'mapa2', 'Mapa2'], ''),
          codigoAtivo: codigoAtivoProposta,
          empreendimento: empreendimento,
          prospecto: {
            codigo: prospectoCodigo,
            codigo_descriptografado: prospectoCodigo,
            nome: 'Prospecto #' + prospectoCodigo,
          },
        });
      })
      .catch(function(err) {
        if (!ativo) return;
        var msg = (err && err.message) ? err.message : 'Falha ao carregar proposta para contraproposta.';
        setErroProposta(msg);
        toast.error(msg);
      })
      .finally(function() {
        if (ativo) setCarregandoProposta(false);
      });

    return function() { ativo = false; };
  }, [codigoProposta]);
  var [parcelasIntermediariasManuais, setParcelasIntermediariasManuais] = useState([]);
  // Altera data-base do cálculo PRICE quando há intermediárias (ResumoVenda.cs:1019).
  // Espelha a venda real: flag mora junto das intermediárias, não no modal de gravação.
  const [isParcelasNaoConcomitantes, setIsParcelasNaoConcomitantes] = useState(false);
  var [deducaoCondicionantes, setDeducaoCondicionantes] = useState(0);
  var [condicionantesAplicadas, setCondicionantesAplicadas] = useState([]);

  // --- Pagamentos do Sinal ---
  // Duas listas separadas igual à venda real: pagamentosIncorp → sinal[] (Setpar),
  // pagamentosMesa → sinal_mesa[] (imobiliária). PagamentosSinalSplit decide qual
  // layout mostrar com base em tipo_recebimento_comissao.
  var [pagamentosIncorp, setPagamentosIncorp] = useState([]);
  var [pagamentosMesa, setPagamentosMesa] = useState([]);
  var [cartoes, setCartoes] = useState([]);
  const [parcelasEmSeries, setParcelasEmSeries] = useState([]);
  const [diaVencimentoProgramadas, setDiaVencimentoProgramadas] = useState(10);

  // --- Divisão de Comissão (apenas RetidaCorretor) ---
  // Espelha venda real (ModalDivisaoComissao): corretor + porcentagem.
  // Simulador é mono-lote, então fica global (não por ativo).
  const [corretores, setCorretores] = useState([]);
  const [divisaoComissao, setDivisaoComissao] = useState({ codigoUsuario: null, porcentagem: '' });
  // Quando truthy, abre o ModalDivisaoComissao (mesmo componente da venda real).
  // Shape espelha o que o modal espera: { codigo, quadra, lote, codigo_usuario, porcentagem }.
  const [divisaoModalAberta, setDivisaoModalAberta] = useState(null);
  const userAtual = AuthStorage.getUser ? AuthStorage.getUser().usuario : null;

  useEffect(() => {
    getGerentes()
      .then(res => {
        const todos = (res || []).reduce((acc, g) => acc.concat(g.corretores || []), []);
        setCorretores(todos.filter(c => c.codigo !== userAtual));
      })
      .catch(() => {});
  }, [userAtual]);

  // --- Condições Especiais ---
  var [condicoesAplicadas, setCondicoesAplicadas] = useState(null);
  var [valoresAlcadaCondicao, setValoresAlcadaCondicao] = useState(VALORES_ALCADA_INICIAIS);

  var isSAC = dados && dados.modalidade === 'S';
  // Taxa Price = juros_por_fora (Emp_Correcao.JrPorfora) para alinhar com a venda real
  // (VendaService.ObterPropostaInicial monta tabela.JurosMensal = JurosPorFora para Price).
  // Em SAC usa taxa_financiamento (TC.Taxa) — mesma regra do backend: modalidade Sac → Taxa.
  // taxa_financiamento sozinho é correção monetária e produzia parcela inflada (W-0075).
  var taxa = (function() {
    if (!dados) return 0;
    if (dados.modalidade === 'S') return (dados.taxa_financiamento || 0) / 100;
    return (dados.juros_por_fora || 0) / 100;
  })();

  // Periodicidade da correção derivada do nome da tabela selecionada (mensal/anual);
  // vazio quando não dá para inferir (o resumo usa o texto genérico).
  var periodicidadeAplicacaoTabela = (function() {
    var label = (tabelaSelecionada && tabelaSelecionada.label ? String(tabelaSelecionada.label) : '').toUpperCase();
    if (label.indexOf('ANUAL') >= 0) return 'anual';
    if (label.indexOf('MENSAL') >= 0) return 'mensal';
    return '';
  })();

  // Habilita as Parcelas Programadas apenas quando o maior plano da tabela tem mais
  // parcelas que o total de programadas — mesma regra usada na venda.
  var exibeParcelasProgramadas = (function() {
    if (!dados || !dados.ativo_escadinha) return false;
    var planos = dados.planos || [];
    var maiorPlanoParcelas = planos.reduce(function(maior, p) {
      var quantidade = Number(p.plano) || 0;
      return quantidade > maior ? quantidade : maior;
    }, 0);
    var escadinhaConfig = dados.ativo_escadinha;
    var totalParcelasProgramadas =
      (Number(escadinhaConfig.parcelas_por_serie) || 0) * (Number(escadinhaConfig.quantidade_de_series) || 0);
    return maiorPlanoParcelas > totalParcelasProgramadas;
  })();

  // --- Options ---
  var tabelaOptions = useMemo(function() {
    if (!dados || !dados.tabelas_disponiveis) return [];
    return dados.tabelas_disponiveis.map(function(t) {
      return { value: t.codigo, label: t.descricao };
    });
  }, [dados]);

  // Quantidade personalizada de parcelas (quando o corretor escolhe "Personalizado")
  var [qtdPersonalizada, setQtdPersonalizada] = useState('');

  const [vencimentoFinanciamento, setVencimentoFinanciamento] = useState('');
  const [vencimentoFinanciamentoManual, setVencimentoFinanciamentoManual] = useState(false);

  var planoOptions = useMemo(function() {
    if (!dados || !dados.planos) return [];
    var opcoes = dados.planos.map(function(p) {
      if (p.plano === 0) {
        return { value: 0, label: 'À Vista', plano: p };
      }
      return { value: p.plano, label: p.plano + 'x', plano: p };
    });
    // Sempre oferece uma opção "Personalizado" no final — corretor digita a qtd.
    opcoes.push({ value: '_custom', label: 'Personalizado…', plano: null, custom: true });
    return opcoes;
  }, [dados]);

  // --- Saldos ---
  // Total de todos os pagamentos de sinal (incorp + mesa combinados).
  // BOLETO/CARTAO com qtd > 1 já vêm expandidos em N items (shape venda real).
  var totalTitulosSinal = useMemo(function() {
    var somaIncorp = pagamentosIncorp.reduce(function(acc, p) { return acc + (p.valor || 0); }, 0);
    var somaMesa = pagamentosMesa.reduce(function(acc, p) { return acc + (p.valor || 0); }, 0);
    return Math.round((somaIncorp + somaMesa) * 100) / 100;
  }, [pagamentosIncorp, pagamentosMesa]);

  // Saldo base: VV - total de títulos de sinal adicionados
  var saldoFinanciarBase = useMemo(function() {
    return Math.round(Math.max(valorVendaEditado - totalTitulosSinal, 0) * 100) / 100;
  }, [valorVendaEditado, totalTitulosSinal]);

  // Entrada esperada (ajustada proporcionalmente se VV foi alterado)
  var valorEntradaEfetiva = useMemo(function() {
    if (!dados) return 0;
    var entOriginal = dados.valor_entrada || 0;
    var vvOriginal = dados.valor_a_vista || 0;
    if (vvOriginal > 0 && valorVendaEditado !== vvOriginal) {
      return Math.round(entOriginal * (valorVendaEditado / vvOriginal) * 100) / 100;
    }
    return entOriginal;
  }, [dados, valorVendaEditado]);

  // Sinal parcial: total informado abaixo da entrada esperada pela tabela. Aciona a
  // autorização (usuário + senha); sem credenciais, a venda vai para a diretoria.
  var sinalParcial = valorEntradaEfetiva > 0 && totalTitulosSinal < valorEntradaEfetiva - 0.01;

  var totalIntermediariasManuaisVP = useMemo(function() {
    var total = 0;
    parcelasIntermediariasManuais.forEach(function(p) {
      total += p.valorPresente || 0;
    });
    return Math.round(total * 100) / 100;
  }, [parcelasIntermediariasManuais]);

  const totalEscadinhaVP = useMemo(() => {
    return Math.round(parcelasEmSeries.reduce((acc, p) => acc + (p.valor_presente || 0), 0) * 100) / 100;
  }, [parcelasEmSeries]);

  const gruposEscadinha = useMemo(() => {
    if (!parcelasEmSeries.length) return [];
    const grupos = [];
    let atual = null;
    const ordenadas = parcelasEmSeries.slice().sort((a, b) => {
      return new Date(a.vencimento) - new Date(b.vencimento);
    });
    ordenadas.forEach((p) => {
      const vf = p.valor || 0;
      const vp = p.valor_presente || 0;
      if (atual && Math.round(atual.valor * 100) === Math.round(vf * 100)) {
        atual.qtd++;
        atual.fim = p.vencimento;
        atual.vpTotal += vp;
      } else {
        if (atual) grupos.push(atual);
        atual = {
          valor: vf,
          valorPresente: vp,
          vpTotal: vp,
          qtd: 1,
          inicio: p.vencimento,
          fim: p.vencimento,
        };
      }
    });
    if (atual) grupos.push(atual);
    return grupos;
  }, [parcelasEmSeries]);

  var saldoFinanciarLiquido = useMemo(function() {
    var s = saldoFinanciarBase - deducaoCondicionantes - totalIntermediariasManuaisVP - totalEscadinhaVP;
    return Math.round(Math.max(s, 0) * 100) / 100;
  }, [saldoFinanciarBase, deducaoCondicionantes, totalIntermediariasManuaisVP, totalEscadinhaVP]);

  const saldoFinanciarProjetado = useMemo(() => {
    return projetarSaldoFinanciamento(
      saldoFinanciarLiquido,
      taxa,
      dataBase,
      parcelasEmSeries,
      vencimentoFinanciamento,
      parcelasIntermediariasManuais,
      isParcelasNaoConcomitantes
    );
  }, [
    saldoFinanciarLiquido,
    taxa,
    dataBase,
    parcelasEmSeries,
    vencimentoFinanciamento,
    parcelasIntermediariasManuais,
    isParcelasNaoConcomitantes,
  ]);


  // --- Financiamento via plano selecionado ---
  // Alinhado com a fórmula da venda real (Utils/Helpers.js → financeiro.price.calcularValorParcela
  // e Pages/Vendas/helpers.js → calcularValorParcelaPlano): a parcela é calculada a partir da
  // taxa da tabela (dados.taxa_financiamento). Quando taxa = 0 (tabela "Próprio" sem juros), é
  // divisão direta saldo/qtd. O coeficiente pré-calculado (p.coeficiente de Tab_Precos_Coef.Coef)
  // é legado e pode estar dessincronizado da taxa real — por isso não é usado aqui.
  var financiamentoPlano = useMemo(function() {
    if (!planoSelecionado) return null;
    // Plano personalizado: usa qtdPersonalizada digitada pelo corretor.
    if (planoSelecionado.custom) {
      var qtdCustom = parseInt(qtdPersonalizada, 10) || 0;
      if (qtdCustom <= 0) return null;
      var maxParcelas = (dados && dados.qtd_max_parcelas) || 9999;
      if (qtdCustom > maxParcelas) return null;
      var valorCustom = isSAC
        ? (saldoFinanciarProjetado / qtdCustom) + (saldoFinanciarProjetado * taxa)
        : calcularValorParcelaPRICE(saldoFinanciarProjetado, taxa, qtdCustom);
      return {
        qtd: qtdCustom,
        valorParcela: Math.round(valorCustom * 100) / 100,
        tipo: isSAC ? 'SAC' : 'PRICE',
      };
    }
    if (!planoSelecionado.plano) return null;
    var p = planoSelecionado.plano;
    if (p.plano === 0) {
      return { qtd: 0, valorParcela: 0, tipo: 'À Vista' };
    }
    var valor;
    if (isSAC) {
      // Primeira parcela SAC = amortização + juros sobre saldo cheio. Com taxa = 0 vira
      // amortização pura, equivalente à divisão direta.
      valor = (saldoFinanciarProjetado / p.plano) + (saldoFinanciarProjetado * taxa);
    } else {
      valor = calcularValorParcelaPRICE(saldoFinanciarProjetado, taxa, p.plano);
    }
    return {
      qtd: p.plano,
      valorParcela: Math.round(valor * 100) / 100,
      tipo: isSAC ? 'SAC' : 'PRICE',
    };
  }, [planoSelecionado, qtdPersonalizada, dados, saldoFinanciarProjetado, isSAC, taxa]);

  // --- Resets ---
  var resetValoresCalculados = useCallback(function() {
    setResultado(null);
    setTabelaAmortizacao(null);
    setAntecipacao(null);
    setResultadoAntecipacao(null);
    setModoSimulacao('V');
    setEntradaCliente('');
    setQtdParcelas('');
    setValorParcela('');
  }, []);

  var limparResultadoFinanciamento = useCallback(function() {
    setResultado(null);
    setTabelaAmortizacao(null);
    setAntecipacao(null);
    setResultadoAntecipacao(null);
  }, []);

  var resetState = useCallback(function() {
    setDados(null);
    setTabelaSelecionada(null);
    setValorVendaEditado(0);
    setPlanoSelecionado(null);
    setQtdPersonalizada('');
    setDeducaoCondicionantes(0);
    setCondicionantesAplicadas([]);
    setParcelasIntermediariasManuais([]);
    setIsParcelasNaoConcomitantes(false);
    setDivisaoComissao({ codigoUsuario: null, porcentagem: '' });
    setPagamentosIncorp([]);
    setPagamentosMesa([]);
    setParcelasEmSeries([]);
    setCondicoesAplicadas(null);
    setMostrarSimulacaoInversa(false);
    setPropostaAlteradaPeloUsuario(false);
    resetValoresCalculados();
    bumpReset();
  }, [resetValoresCalculados, bumpReset]);

  var marcarAlteracaoProposta = useCallback(function() {
    if (isModoProposta && propostaHidratada === codigoProposta) {
      setPropostaAlteradaPeloUsuario(true);
    }
  }, [codigoProposta, isModoProposta, propostaHidratada]);

  var handleValorVendaChange = useCallback(function(novoValor) {
    marcarAlteracaoProposta();
    var condicoesBase = condicoesAplicadas
      || (propostaOriginalSnapshot && propostaOriginalSnapshot.condicoesAplicadas)
      || null;
    var statusSnapshot = propostaOriginalSnapshot ? propostaOriginalSnapshot.status : null;
    var statusBase = statusSnapshot !== undefined && statusSnapshot !== null
      ? statusSnapshot
      : (condicoesBase ? condicoesBase.status : null);
    var devePreservarCondicaoProposta = isModoProposta
      && condicoesBase
      && statusBase === CondicoesEspeciaisStatus.PendenteDiretoria;

    setValorVendaEditado(novoValor);
    setPagamentosIncorp([]);
    setPagamentosMesa([]);
    setParcelasEmSeries([]);
    setCondicoesAplicadas(devePreservarCondicaoProposta
      ? atualizarValorLoteCondicao(condicoesBase, dados ? dados.valor_a_vista || 0 : 0, novoValor)
      : null);
    setDeducaoCondicionantes(0);
    setCondicionantesAplicadas([]);
    setParcelasIntermediariasManuais([]);
    resetValoresCalculados();
    bumpReset();
  }, [condicoesAplicadas, dados, isModoProposta, marcarAlteracaoProposta, propostaOriginalSnapshot, resetValoresCalculados, bumpReset]);

  var handleDataBaseChange = useCallback(function(novaData) {
    marcarAlteracaoProposta();
    setDataBase(novaData);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  var handlePlanoChange = useCallback(function(option) {
    marcarAlteracaoProposta();
    setPlanoSelecionado(option);
    // Limpa a qtd personalizada ao trocar de plano. Só preserva se ficar no "Personalizado".
    if (!option || !option.custom) {
      setQtdPersonalizada('');
    }
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  // --- Callback condicionantes ---
  var handleCondicionantesChange = useCallback(function(deducao) {
    marcarAlteracaoProposta();
    setDeducaoCondicionantes(deducao);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  var handleCondicionantesLinhasChange = useCallback(function(linhas) {
    marcarAlteracaoProposta();
    setCondicionantesAplicadas(linhas);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  var handlePagamentosIncorpChange = useCallback(function(next) {
    marcarAlteracaoProposta();
    setPagamentosIncorp(next);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  var handlePagamentosMesaChange = useCallback(function(next) {
    marcarAlteracaoProposta();
    setPagamentosMesa(next);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  var handleParcelasIntermediariasChange = useCallback(function(next) {
    marcarAlteracaoProposta();
    setParcelasIntermediariasManuais(next);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  var handleParcelasNaoConcomitantesChange = useCallback(function(next) {
    marcarAlteracaoProposta();
    setIsParcelasNaoConcomitantes(next);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  var handleParcelasProgramadasChange = useCallback(function(next) {
    marcarAlteracaoProposta();
    setParcelasEmSeries(next);
    limparResultadoFinanciamento();
  }, [limparResultadoFinanciamento, marcarAlteracaoProposta]);

  // --- Condições Especiais ---
  var handleAplicarCondicoes = useCallback(function(condicoes) {
    if (condicaoPossuiCarencia(condicoes) && parcelasEmSeries.length > 0) {
      toast.warn('Remova as Parcelas Programadas antes de aplicar uma condição especial de carência.');
      return;
    }

    marcarAlteracaoProposta();
    var condicoesComAlcada = Object.assign(
      {},
      condicoes,
      calcularAlcadaCondicaoEspecial(condicoes, valoresAlcadaCondicao)
    );
    var statusPropostaOriginal = propostaOriginalSnapshot ? propostaOriginalSnapshot.status : null;
    var statusPropostaAtual = condicoesAplicadas ? condicoesAplicadas.status : null;
    if (
      isModoProposta
      && (statusPropostaOriginal === CondicoesEspeciaisStatus.PendenteDiretoria
        || statusPropostaAtual === CondicoesEspeciaisStatus.PendenteDiretoria)
    ) {
      condicoesComAlcada = Object.assign({}, condicoesComAlcada, {
        status: CondicoesEspeciaisStatus.PendenteDiretoria,
        travarVenda: { travarCorretor: true, travarGerente: true },
        avisoAlcada: avisoAlcadaSolicitacaoExistente(CondicoesEspeciaisStatus.PendenteDiretoria)
          || condicoesComAlcada.avisoAlcada,
      });
    }
    setCondicoesAplicadas(condicoesComAlcada);
    if (condicoesComAlcada.valorLote && condicoesComAlcada.valorLote.isAtivo && condicoesComAlcada.valorLote.valorSugerido > 0) {
      setValorVendaEditado(condicoesComAlcada.valorLote.valorSugerido);
    }
    setPagamentosIncorp([]);
    setPagamentosMesa([]);
    setParcelasEmSeries([]);
    setDeducaoCondicionantes(0);
    setCondicionantesAplicadas([]);
    setParcelasIntermediariasManuais([]);
    resetValoresCalculados();
    bumpReset();
  }, [condicoesAplicadas, isModoProposta, marcarAlteracaoProposta, parcelasEmSeries, propostaOriginalSnapshot, valoresAlcadaCondicao, resetValoresCalculados, bumpReset]);

  var handleRemoverCondicoes = useCallback(function() {
    var condicoesBase = condicoesAplicadas
      || (propostaOriginalSnapshot && propostaOriginalSnapshot.condicoesAplicadas)
      || null;
    if (isModoProposta && condicoesBase) {
      toast.warn('Não é possível remover a condição especial de uma solicitação já gravada. Ajuste os valores para enviar uma contraproposta.');
      return false;
    }

    marcarAlteracaoProposta();
    setCondicoesAplicadas(null);
    if (dados) setValorVendaEditado(dados.valor_a_vista || 0);
    setPagamentosIncorp([]);
    setPagamentosMesa([]);
    setParcelasEmSeries([]);
    setDeducaoCondicionantes(0);
    setCondicionantesAplicadas([]);
    setParcelasIntermediariasManuais([]);
    resetValoresCalculados();
    bumpReset();
    return true;
  }, [condicoesAplicadas, dados, isModoProposta, marcarAlteracaoProposta, propostaOriginalSnapshot, resetValoresCalculados, bumpReset]);

  // --- Carregar dados ---
  var carregarDados = useCallback(
    async function(codigoTabela) {
      try {
        setIsLoading(true);
        resetValoresCalculados();
        setDeducaoCondicionantes(0);
        setCondicionantesAplicadas([]);
        setParcelasIntermediariasManuais([]);
        setIsParcelasNaoConcomitantes(false);
        setPagamentosIncorp([]);
        setPagamentosMesa([]);
        setParcelasEmSeries([]);
        if (codigoProposta) {
          setCondicoesAplicadas(function(atuais) {
            return atuais ? Object.assign({}, atuais) : atuais;
          });
        } else {
          setCondicoesAplicadas(null);
        }
        setPlanoSelecionado(null);
        setQtdPersonalizada('');
        bumpReset();

        var response = await buscarSimulacaoFinanciamento(codigoAtivo, codigoTabela);
        setDados(response);

        if (response) {
          if (!codigoProposta) {
            setValorVendaEditado(response.valor_a_vista || 0);
          }
          setEntradaCliente(Math.round((response.valor_entrada || 0) * 100) / 100);
          var tabelaAtual = (response.tabelas_disponiveis || []).find(function(t) {
            return t.codigo === response.codigo_tabela;
          });
          if (tabelaAtual) {
            setTabelaSelecionada({ value: tabelaAtual.codigo, label: tabelaAtual.descricao });
          }
        }
      } catch (err) {
        toast.error((err && err.message) || 'Falha ao carregar dados da simulação.');
      } finally {
        setIsLoading(false);
      }
    },
    [codigoAtivo, codigoProposta, resetValoresCalculados, bumpReset]
  );

  var codigoTabelaProposta = propostaAuxiliar && propostaAuxiliar.gravada
    ? pickCampo(propostaAuxiliar.gravada, ['tabela_selecionada', 'tabelaSelecionada'], null)
    : null;

  useEffect(function() {
    if (codigoAtivo) { carregarDados(codigoTabelaProposta); }
    else { resetState(); }
  }, [codigoAtivo, codigoTabelaProposta, carregarDados, resetState]);

  var codigoFamilia = contextoSelecao && contextoSelecao.codigoFamilia;
  useEffect(function() {
    if (!codigoFamilia) { setCartoes([]); return; }
    buscarCartoesSimulador(codigoFamilia)
      .then(function(res) { setCartoes(Array.isArray(res) ? res : []); })
      .catch(function() { setCartoes([]); });
  }, [codigoFamilia]);

  useEffect(function() {
    var cancelado = false;
    if (!codigoFamilia) {
      setValoresAlcadaCondicao(VALORES_ALCADA_INICIAIS);
      return function() { cancelado = true; };
    }
    pegarValoresAlcadas(codigoFamilia)
      .then(function(res) {
        if (!cancelado) setValoresAlcadaCondicao(normalizarValoresAlcada(res));
      })
      .catch(function() {
        if (!cancelado) setValoresAlcadaCondicao(VALORES_ALCADA_INICIAIS);
      });
    return function() { cancelado = true; };
  }, [codigoFamilia]);

  var handleTrocarTabela = useCallback(function(option) {
    marcarAlteracaoProposta();
    setTabelaSelecionada(option);
    if (option) carregarDados(option.value);
  }, [carregarDados, marcarAlteracaoProposta]);

  useEffect(function() {
    if (!codigoProposta || !dados || !propostaAuxiliar || propostaHidratada === codigoProposta) return;

    var gravada = propostaAuxiliar.gravada;
    var ativoGravado = propostaAuxiliar.ativo;
    var financiamento = ativoGravado && pickCampo(ativoGravado, ['financiamento', 'Financiamento'], {});
    var condicoesLocal = mapCondicoesProposta(
      pickCampo(gravada, ['condicoes_especiais', 'condicoesEspeciais'], null),
      valoresAlcadaCondicao
    );
    var condicionantes = mapCondicionantesProposta(
      pickCampo(ativoGravado, ['parcelas_condicionantes', 'parcelasCondicionantes'], [])
    );
    var intermediarias = mapParcelasIntermediariasProposta(
      pickCampo(ativoGravado, ['parcelas_intermediarias', 'parcelasIntermediarias'], [])
    );
    var programadas = mapParcelasProgramadasProposta(
      pickCampo(ativoGravado, ['parcelas_em_series', 'parcelasEmSeries'], [])
    );
    var codigoTabela = pickCampo(gravada, ['tabela_selecionada', 'tabelaSelecionada'], dados.codigo_tabela);
    var tabelaAtual = (dados.tabelas_disponiveis || []).find(function(t) {
      return String(t.codigo) === String(codigoTabela);
    });
    var vencimentoFin = normalizarDataInput(pickCampo(financiamento, ['vencimento', 'Vencimento'], ''));
    var financiamentoResumo = {
      qtd: normalizarNumero(pickCampo(financiamento, ['quantidade_parcelas', 'quantidadeParcelas', 'QuantidadeParcelas'], 0)),
      valorParcela: normalizarNumero(pickCampo(financiamento, ['valor', 'Valor'], 0)),
      tipo: isSAC ? 'SAC' : 'PRICE',
    };
    var dataProposta = normalizarDataInput(pickCampo(gravada, ['data', 'Data'], '')) || dataBase;
    var valorVendaOriginalProposta = dados.valor_a_vista || 0;
    var valorVendaAtivoProposta = normalizarNumero(pickCampo(ativoGravado, ['valor_venda', 'valorVenda'], valorVendaOriginalProposta));
    var valorVendaProposta = obterValorVendaPropostaComCondicao(valorVendaAtivoProposta, condicoesLocal, valorVendaOriginalProposta);
    if (condicoesLocal && condicoesLocal.valorLote && condicoesLocal.valorLote.isAtivo) {
      condicoesLocal = atualizarValorLoteCondicao(condicoesLocal, valorVendaOriginalProposta, valorVendaProposta);
    }
    var tabelaSelecionadaProposta = tabelaAtual ? { value: tabelaAtual.codigo, label: tabelaAtual.descricao } : null;
    var planoSelecionadoProposta = criarPlanoSelecionadoProposta(financiamentoResumo, dados);
    var isParcelasNaoConcomitantesProposta = !!pickCampo(gravada, ['is_parcelas_nao_concomitantes', 'isParcelasNaoConcomitantes'], false);
    var codigoCorretorProposta = pickCampo(gravada, ['codigo_usuario', 'codigoUsuario'], null);
    var divisaoComissaoAtivo = pickCampo(ativoGravado, ['divisao_comissao', 'divisaoComissao'], null);
    var divisaoComissaoProposta = divisaoComissaoAtivo ? {
      codigoUsuario: pickCampo(divisaoComissaoAtivo, ['codigo_usuario', 'codigoUsuario'], null),
      porcentagem: pickCampo(divisaoComissaoAtivo, ['porcentagem', 'Porcentagem'], ''),
    } : { codigoUsuario: null, porcentagem: '' };
    var sinalProposta = (pickCampo(gravada, ['sinal', 'Sinal'], []) || []).map(mapPagamentoProposta);
    var sinalMesaProposta = (pickCampo(gravada, ['sinal_mesa', 'sinalMesa', 'SinalMesa'], []) || []).map(mapPagamentoProposta);

    setDataBase(dataProposta);
    setValorVendaEditado(valorVendaProposta);
    setTabelaSelecionada(tabelaSelecionadaProposta);
    setPlanoSelecionado(planoSelecionadoProposta);
    setQtdPersonalizada('');
    setPagamentosIncorp(sinalProposta);
    setPagamentosMesa(sinalMesaProposta);
    setCondicoesAplicadas(condicoesLocal);
    setCondicionantesAplicadas(condicionantes);
    setDeducaoCondicionantes(condicionantes.reduce(function(acc, item) {
      return acc + (item.valorPresente || 0);
    }, 0));
    setParcelasIntermediariasManuais(intermediarias);
    setParcelasEmSeries(programadas);
    setIsParcelasNaoConcomitantes(isParcelasNaoConcomitantesProposta);
    setResultado(null);
    setTabelaAmortizacao(null);
    setVencimentoFinanciamento(vencimentoFin);
    setVencimentoFinanciamentoManual(!!vencimentoFin);
    setCorretorAtivo(codigoCorretorProposta);
    if (codigoCorretorProposta) {
      setOpcoesCorretores(function(lista) {
        var existentes = Array.isArray(lista) ? lista : [];
        var jaExiste = existentes.some(function(item) {
          return String(item.codigo) === String(codigoCorretorProposta);
        });
        if (jaExiste) return existentes;
        return [{ codigo: codigoCorretorProposta, descricao: 'Corretor ' + codigoCorretorProposta }].concat(existentes);
      });
    }
    setDivisaoComissao(divisaoComissaoProposta);
    setPropostaOriginalSnapshot({
      status: condicoesLocal ? condicoesLocal.status : null,
      condicoesAplicadas: condicoesLocal,
      condicoes: normalizarCondicaoComparacao(condicoesLocal),
      financiamento: normalizarFinanciamentoComparacao(financiamentoResumo, vencimentoFin),
      fluxo: normalizarFluxoContraproposta({
        pagamentosIncorp: sinalProposta,
        pagamentosMesa: sinalMesaProposta,
        condicionantesAplicadas: condicionantes,
        parcelasIntermediariasManuais: intermediarias,
        parcelasEmSeries: programadas,
      }),
      venda: normalizarVendaContraproposta({
        valorVendaEditado: valorVendaProposta,
        dataBase: dataProposta,
        tabelaSelecionada: tabelaSelecionadaProposta,
        isParcelasNaoConcomitantes: isParcelasNaoConcomitantesProposta,
        divisaoComissao: divisaoComissaoProposta,
      }),
    });
    setPropostaAlteradaPeloUsuario(false);
    setPropostaHidratada(codigoProposta);
  }, [
    codigoProposta,
    dados,
    propostaAuxiliar,
    propostaHidratada,
    valoresAlcadaCondicao,
    dataBase,
    isSAC,
    saldoFinanciarProjetado,
  ]);

  // --- Simulação inversa ---
  var handleSimular = useCallback(function() {
    if (!dados) return;
    marcarAlteracaoProposta();
    var entrada = parseFloat(entradaCliente) || 0;
    var qtd = parseInt(qtdParcelas, 10) || 0;
    var valParc = parseFloat(valorParcela) || 0;
    var vv = valorVendaEditado;

    var saldoFinanciar, resEntrada, resQtd, resValor, resUltima, entradaAlterada = false;

    if (modoSimulacao === 'V') {
      saldoFinanciar = saldoFinanciarProjetado;
      if (qtd > (dados.qtd_max_parcelas || 9999)) { toast.warning('Quantidade máxima de parcelas: ' + (dados.qtd_max_parcelas || 9999)); return; }
      if (isSAC) {
        resValor = qtd > 0 ? Math.round((saldoFinanciar / qtd + saldoFinanciar * taxa) * 100) / 100 : 0;
      } else {
        resValor = calcularValorParcelaPRICE(saldoFinanciar, taxa, qtd);
      }
      resEntrada = entrada; resQtd = qtd; resUltima = 0;
    } else if (modoSimulacao === 'Q') {
      saldoFinanciar = saldoFinanciarProjetado;
      var qtdCalc = isSAC ? calcularQtdParcelasSAC(saldoFinanciar, taxa, valParc) : calcularQtdParcelasPRICE(saldoFinanciar, taxa, valParc);
      if (qtdCalc <= 0) { toast.warning('Não foi possível calcular a quantidade de parcelas com os valores informados.'); return; }
      var ajuste = ajustarRestoQtdParcelas(qtdCalc, valParc, saldoFinanciar, entrada, vv);
      resQtd = ajuste.qtdParcelas; entradaAlterada = ajuste.entradaAlterada;
      resEntrada = ajuste.entradaAlterada ? ajuste.novaEntrada : entrada;
      resValor = valParc; resUltima = 0;
      if (resQtd > (dados.qtd_max_parcelas || 9999)) { toast.warning('Quantidade máxima de parcelas: ' + (dados.qtd_max_parcelas || 9999)); return; }
    } else if (modoSimulacao === 'E') {
      if (isSAC) { toast.warning('Não é possível calcular a entrada na tabela SAC.'); return; }
      resEntrada = calcularEntradaPRICE(vv, taxa, qtd, valParc);
      if (resEntrada <= 0) { toast.warning('Diminua o valor da parcela ou a quantidade de parcelas.'); return; }
      if (resEntrada < dados.entrada_imobiliaria) { toast.warning('Entrada calculada é menor que a entrada imobiliária.'); return; }
      saldoFinanciar = vv - resEntrada - deducaoCondicionantes - totalIntermediariasManuaisVP - totalEscadinhaVP;
      if (saldoFinanciar < 0) saldoFinanciar = 0;
      saldoFinanciar = projetarSaldoFinanciamento(
        saldoFinanciar,
        taxa,
        dataBase,
        parcelasEmSeries,
        vencimentoFinanciamento,
        parcelasIntermediariasManuais,
        isParcelasNaoConcomitantes
      );
      resQtd = qtd; resValor = valParc; resUltima = 0;
    }

    setResultado({
      entrada: Math.round(resEntrada * 100) / 100,
      qtdParcelas: resQtd,
      valorParcela: Math.round(resValor * 100) / 100,
      valorUltimaParcela: Math.round((resUltima || 0) * 100) / 100,
      saldoFinanciar: Math.round((saldoFinanciar || 0) * 100) / 100,
      entradaAlterada: entradaAlterada,
      isSAC: isSAC,
    });

    if (saldoFinanciar > 0 && resQtd > 0) {
      if (isSAC) setTabelaAmortizacao(gerarTabelaSAC(saldoFinanciar, taxa, resQtd));
      else if (resValor > 0) setTabelaAmortizacao(gerarTabelaPRICE(saldoFinanciar, taxa, resQtd, resValor));
      else setTabelaAmortizacao(null);
    } else { setTabelaAmortizacao(null); }

    // Limpa o valor da antecipação específica; o useEffect abaixo recalcula
    // a tabela de antecipação com base no financiamentoAtivo (plano ou simulação inversa).
    setResultadoAntecipacao(null);
  }, [
    dados,
    entradaCliente,
    qtdParcelas,
    valorParcela,
    modoSimulacao,
    isSAC,
    taxa,
    valorVendaEditado,
    saldoFinanciarProjetado,
    deducaoCondicionantes,
    totalIntermediariasManuaisVP,
    totalEscadinhaVP,
    dataBase,
    parcelasEmSeries,
    vencimentoFinanciamento,
    parcelasIntermediariasManuais,
    isParcelasNaoConcomitantes,
    marcarAlteracaoProposta,
  ]);

  var handleLimpar = useCallback(function() {
    marcarAlteracaoProposta();
    resetValoresCalculados();
    if (dados) setEntradaCliente(Math.round((dados.valor_entrada || 0) * 100) / 100);
  }, [dados, marcarAlteracaoProposta, resetValoresCalculados]);

  // Espelha venda real (Components/Vendas/Financiamento/index.js:628): valor da
  // 1ª série vem do cadastro do lote (escadinha.parcela_inicial). Corretor não digita.
  const handleGerarEscadinha = useCallback(() => {
    const escadinha = dados && dados.ativo_escadinha;
    if (!escadinha) return;
    if (condicaoPossuiCarencia(condicoesAplicadas)) {
      toast.warn(MENSAGEM_PROGRAMADAS_COM_CARENCIA);
      return;
    }
    if (!escadinha.parcela_inicial || escadinha.parcela_inicial <= 0) {
      toast.warning('Configuração da escadinha do lote está incompleta (parcela_inicial não definida)');
      return;
    }
    const pagamentosSinal = pagamentosIncorp.concat(pagamentosMesa);
    const vencimentosSinalOrdenados = Array.from(new Set(
      pagamentosSinal
        .map((p) => normalizarDataInput(pickCampo(p, ['vencimento', 'Vencimento'], '')))
        .filter(Boolean)
    )).sort();
    const qtdParcelasSinalAposPrimeira = vencimentosSinalOrdenados.length > 0
      ? Math.max(0, vencimentosSinalOrdenados.length - 1)
      : Math.max(0, pagamentosSinal.length - 1);
    const ultimoVencimentoSinal = vencimentosSinalOrdenados.length > 0
      ? vencimentosSinalOrdenados[vencimentosSinalOrdenados.length - 1]
      : null;
    handleParcelasProgramadasChange(
      gerarSeriesEscadinha(
        escadinha,
        dataBase,
        taxa,
        qtdParcelasSinalAposPrimeira,
        ultimoVencimentoSinal,
        diaVencimentoProgramadas
      )
    );
  }, [
    dados,
    dataBase,
    taxa,
    pagamentosIncorp,
    pagamentosMesa,
    condicoesAplicadas,
    diaVencimentoProgramadas,
    handleParcelasProgramadasChange,
  ]);

  // Simula antecipação a partir da lista unificada (sinal + cond + interm + fin).
  // Direção: 'inicio' (primeiras N parcelas em ordem cronológica) ou 'fim' (últimas).
  var handleSimularAntecipacao = useCallback(function(qtdEspecifica, direcao) {
    if (!antecipacao || !antecipacao.__snapshot || !antecipacao.__snapshot.parcelas) {
      toast.warn('Adicione parcelas (sinal, condicionantes, intermediárias ou financiamento) antes');
      return;
    }
    var snap = antecipacao.__snapshot;
    var totalParc = snap.parcelas.length;
    if (!qtdEspecifica || qtdEspecifica <= 0) {
      toast.warn('Informe uma quantidade de parcelas válida');
      return;
    }
    if (qtdEspecifica > totalParc) {
      toast.warn('Quantidade maior que o total de parcelas (' + totalParc + ')');
      return;
    }
    var resumo = calcularResumoAntecipacaoUnificado(
      snap.parcelas,
      qtdEspecifica,
      direcao || 'fim',
      snap.saldoFinanciar
    );
    setResultadoAntecipacao(resumo);
  }, [antecipacao]);

  // W-0075 (devolução): simula antecipação informando valor em R$ em vez de qtd.
  var handleSimularAntecipacaoPorValor = useCallback(function(valorEspecifico, direcao) {
    if (!antecipacao || !antecipacao.__snapshot || !antecipacao.__snapshot.parcelas) {
      toast.warn('Adicione parcelas (sinal, condicionantes, intermediárias ou financiamento) antes');
      return;
    }
    if (!valorEspecifico || valorEspecifico <= 0) {
      toast.warn('Informe um valor válido para antecipar');
      return;
    }
    var snap = antecipacao.__snapshot;
    var resumo = calcularResumoAntecipacaoUnificadoPorValor(
      snap.parcelas,
      valorEspecifico,
      direcao || 'fim',
      snap.saldoFinanciar
    );
    setResultadoAntecipacao(resumo);
  }, [antecipacao]);

  // --- Financiamento ativo (plano OU simulação inversa) ---
  var financiamentoAtivo = useMemo(function() {
    if (resultado) {
      return { qtd: resultado.qtdParcelas, valorParcela: resultado.valorParcela, tipo: isSAC ? 'SAC' : 'PRICE' };
    }
    if (financiamentoPlano) return financiamentoPlano;
    return null;
  }, [resultado, financiamentoPlano, isSAC]);

  var temCarenciaCondicaoEspecial = !!(
    condicoesAplicadas &&
    condicoesAplicadas.financiamento &&
    condicoesAplicadas.financiamento.isAtivo &&
    Number(condicoesAplicadas.financiamento.meses || 0) > 0
  );
  var vencimentoMinimoFinanciamento = useMemo(function() {
    return calcularVencimentoFinanciamentoDefault(
      dataBase,
      pagamentosIncorp,
      pagamentosMesa,
      condicoesAplicadas,
      parcelasEmSeries
    );
  }, [
    dataBase,
    pagamentosIncorp,
    pagamentosMesa,
    condicoesAplicadas,
    parcelasEmSeries,
  ]);
  var vencimentoMinimoCarencia = useMemo(function() {
    return calcularVencimentoMinimoCarencia(dataBase, condicoesAplicadas);
  }, [dataBase, condicoesAplicadas]);
  var vencimentoFinanciamentoAntesCarencia = temCarenciaCondicaoEspecial
    && vencimentoFinanciamento
    && vencimentoMinimoCarencia
    && moment(vencimentoFinanciamento).isBefore(moment(vencimentoMinimoCarencia), 'day');

  useEffect(function() {
    if (vencimentoFinanciamentoManual) return;
    setVencimentoFinanciamento(vencimentoMinimoFinanciamento);
  }, [
    vencimentoMinimoFinanciamento,
    vencimentoFinanciamentoManual,
  ]);

  // Recalcula a tabela de antecipação unificada (W-0075 devolução pt.2) sempre
  // que alguma das fontes de parcela muda: sinal, condicionantes, intermediárias
  // manuais, financiamento ativo. Cada parcela vai pra lista com seu próprio VP
  // já calculado (sinal sem taxa = VP=VF; cond/interm com taxaPI já vem do payload;
  // financiamento com taxa do plano).
  useEffect(function() {
    if (!dados) {
      setAntecipacao(null);
      return;
    }

    var parcelas = [];
    var labelByCodigo = { 1: 'Boleto', 2: 'Cheque', 3: 'Dinheiro', 4: 'Cartão', 5: 'Depósito/PIX' };

    // --- Sinal (incorp + mesa) — sem taxa, VP = VF ---
    // W-0075 (devolução SINAL pt.3): só BOLETO entra no cálculo de antecipação.
    // Demais formas (PIX/Depósito/Dinheiro/Cartão/Cheque) ficam no grid como informativo
    // (linha verde/disabled), porque equivalem a entrada à vista.
    (pagamentosIncorp || []).forEach(function(p) {
      parcelas.push({
        tipo: 'Sinal',
        tipoLabel: 'Sinal' + (labelByCodigo[p.tipo_parcela] ? ' · ' + labelByCodigo[p.tipo_parcela] : ''),
        valor: p.valor,
        valorPresente: p.valor,
        vencimento: p.vencimento,
        antecipavel: p.tipo_parcela === 1,
      });
    });
    (pagamentosMesa || []).forEach(function(p) {
      parcelas.push({
        tipo: 'Sinal',
        tipoLabel: 'Sinal Imob.' + (labelByCodigo[p.tipo_parcela] ? ' · ' + labelByCodigo[p.tipo_parcela] : ''),
        valor: p.valor,
        valorPresente: p.valor,
        vencimento: p.vencimento,
        antecipavel: p.tipo_parcela === 1,
      });
    });

    // --- Condicionantes — VP já vem calculado com taxaPI ---
    (condicionantesAplicadas || []).forEach(function(c) {
      parcelas.push({
        tipo: 'Condicionante',
        tipoLabel: c.tipo || 'Condicionante',
        valor: c.valorFuturo,
        valorPresente: c.valorPresente,
        vencimento: c.vencimento,
      });
    });

    // --- Intermediárias manuais — VP já vem calculado com taxaPI ---
    (parcelasIntermediariasManuais || []).forEach(function(it) {
      parcelas.push({
        tipo: 'Intermediária',
        tipoLabel: 'Intermediária',
        valor: it.valorFuturo,
        valorPresente: it.valorPresente,
        vencimento: it.vencimento,
      });
    });

    // --- Programadas / escadinha — VP já foi calculado na geração das séries ---
    (parcelasEmSeries || []).forEach(function(p) {
      parcelas.push({
        tipo: 'Programada',
        tipoLabel: 'Programada',
        valor: p.valor,
        valorPresente: p.valor_presente,
        vencimento: p.vencimento,
      });
    });

    // --- Financiamento — gera N parcelas com VP por mês usando taxa do plano ---
    if (
      financiamentoAtivo &&
      financiamentoAtivo.qtd > 0 &&
      financiamentoAtivo.valorParcela > 0 &&
      saldoFinanciarProjetado > 0 &&
      vencimentoFinanciamento
    ) {
      var taxaFin = isSAC
        ? (dados.taxa_financiamento || 0)
        : (dados.juros_por_fora || 0);
      var vencBase = moment(vencimentoFinanciamento);
      for (var i = 0; i < financiamentoAtivo.qtd; i++) {
        parcelas.push({
          tipo: 'Financiamento',
          tipoLabel: 'Financ. ' + (isSAC ? 'SAC' : 'PRICE'),
          valor: financiamentoAtivo.valorParcela,
          valorPresente: calcularValorPresente(financiamentoAtivo.valorParcela, taxaFin, i),
          vencimento: vencBase.clone().add(i, 'months').format('YYYY-MM-DD'),
        });
      }
    }

    if (parcelas.length === 0) {
      setAntecipacao(null);
      return;
    }

    // Ordena cronologicamente — base pra "antecipar do início" / "do fim".
    parcelas.sort(function(a, b) { return new Date(a.vencimento) - new Date(b.vencimento); });

    var tabela = gerarTabelaAntecipacaoUnificada(parcelas, saldoFinanciarProjetado);
    setAntecipacao(Object.assign({}, tabela, {
      __snapshot: {
        parcelas: tabela.parcelas,
        saldoFinanciar: saldoFinanciarProjetado,
      },
    }));
  }, [
    financiamentoAtivo,
    dados,
    saldoFinanciarProjetado,
    isSAC,
    vencimentoFinanciamento,
    pagamentosIncorp,
    pagamentosMesa,
    condicionantesAplicadas,
    parcelasIntermediariasManuais,
    parcelasEmSeries,
  ]);

  var selectStyles = useMemo(function() {
    return Object.assign({}, customStylesSm, {
      menuPortal: function(base) { return Object.assign({}, base, { zIndex: 99999 }); },
    });
  }, []);

  var condicoesOriginaisProposta = propostaOriginalSnapshot && propostaOriginalSnapshot.condicoesAplicadas
    ? propostaOriginalSnapshot.condicoesAplicadas
    : null;
  var condicoesAplicadasFluxo = condicoesAplicadas || condicoesOriginaisProposta;

  // W-0075 (devolução): mesma validação do botão "Gerar Venda", reaproveitada
  // para destravar os botões "Copiar" e "Imprimir" do Resumo. Quando há lote/plano
  // selecionado mas algo falta (valor da venda, vencimento, etc), os botões ficam
  // desabilitados com tooltip explicando.
  var errosResumoExportar = useMemo(function() {
    if (!contextoSelecao || !contextoSelecao.codigoFamilia) return ['Selecione um empreendimento.'];
    if (!codigoAtivo) return ['Selecione um lote.'];
    if (!financiamentoAtivo) return ['Selecione um plano de financiamento.'];
    return validarPayloadAntesAbrirModal({
      dados: dados,
      codigoAtivo: codigoAtivo,
      codigoFamilia: contextoSelecao && contextoSelecao.codigoFamilia,
      valorVendaEditado: valorVendaEditado,
      dataBase: dataBase,
      financiamentoPlano: financiamentoAtivo,
      vencimentoFinanciamento: vencimentoFinanciamento,
      saldoFinanciarLiquido: saldoFinanciarProjetado,
      pagamentosIncorp: pagamentosIncorp,
      pagamentosMesa: pagamentosMesa,
      parcelasEmSeries: parcelasEmSeries,
      parcelasIntermediariasManuais: parcelasIntermediariasManuais,
      condicionantesAplicadas: condicionantesAplicadas,
      condicoesAplicadas: condicoesAplicadasFluxo,
      isParcelasNaoConcomitantes: isParcelasNaoConcomitantes,
      divisaoComissao: divisaoComissao,
    });
  }, [
    contextoSelecao,
    codigoAtivo,
    dados,
    valorVendaEditado,
    dataBase,
    financiamentoAtivo,
    vencimentoFinanciamento,
    saldoFinanciarProjetado,
    pagamentosIncorp,
    pagamentosMesa,
    parcelasEmSeries,
    parcelasIntermediariasManuais,
    condicionantesAplicadas,
    condicoesAplicadasFluxo,
    isParcelasNaoConcomitantes,
    divisaoComissao,
  ]);
  var podeExportarResumo = errosResumoExportar.length === 0;

  var temCaracteristicaContraproposta = AuthStorage.temCaracteristica(552);
  var statusCondicaoAtual = condicoesAplicadasFluxo ? condicoesAplicadasFluxo.status : null;
  var statusCondicaoOriginal = propostaOriginalSnapshot ? propostaOriginalSnapshot.status : null;
  var statusCondicaoFluxo = statusCondicaoOriginal !== undefined && statusCondicaoOriginal !== null
    ? statusCondicaoOriginal
    : statusCondicaoAtual;
  var condicoesComparacaoAtual = normalizarCondicaoComparacao(condicoesAplicadasFluxo);
  var financiamentoComparacaoAtual = normalizarFinanciamentoComparacao(financiamentoAtivo, vencimentoFinanciamento);
  var fluxoComparacaoAtual = normalizarFluxoContraproposta({
    pagamentosIncorp: pagamentosIncorp,
    pagamentosMesa: pagamentosMesa,
    condicionantesAplicadas: condicionantesAplicadas,
    parcelasIntermediariasManuais: parcelasIntermediariasManuais,
    parcelasEmSeries: parcelasEmSeries,
  });
  var vendaComparacaoAtual = normalizarVendaContraproposta({
    valorVendaEditado: valorVendaEditado,
    dataBase: dataBase,
    tabelaSelecionada: tabelaSelecionada,
    isParcelasNaoConcomitantes: isParcelasNaoConcomitantes,
    divisaoComissao: divisaoComissao,
  });
  var mudouCondicoesContraproposta = propostaOriginalSnapshot
    ? JSON.stringify(propostaOriginalSnapshot.condicoes) !== JSON.stringify(condicoesComparacaoAtual)
    : false;
  var mudouFinanciamentoContraproposta = propostaOriginalSnapshot
    ? JSON.stringify(propostaOriginalSnapshot.financiamento) !== JSON.stringify(financiamentoComparacaoAtual)
    : false;
  var mudouFluxoContraproposta = propostaOriginalSnapshot
    ? JSON.stringify(propostaOriginalSnapshot.fluxo) !== JSON.stringify(fluxoComparacaoAtual)
    : false;
  var mudouVendaContraproposta = propostaOriginalSnapshot
    ? JSON.stringify(propostaOriginalSnapshot.venda) !== JSON.stringify(vendaComparacaoAtual)
    : false;
  var houveDiferencaParaContraproposta = mudouCondicoesContraproposta
    || mudouFinanciamentoContraproposta
    || mudouFluxoContraproposta
    || mudouVendaContraproposta;
  var houveAlteracaoParaContraproposta = propostaAlteradaPeloUsuario && houveDiferencaParaContraproposta;
  var isGerenteVendoPendenteDiretoria = isModoProposta
    && AuthStorage.isGerente()
    && statusCondicaoFluxo === CondicoesEspeciaisStatus.PendenteDiretoria
    && !temCaracteristicaContraproposta;
  var isUsuarioSemAcaoContraproposta = isModoProposta
    && statusCondicaoFluxo === CondicoesEspeciaisStatus.Contraproposta
    && (AuthStorage.isGerente() || temCaracteristicaContraproposta);
  var operacaoProposta = 'gravar';
  if (isModoProposta) {
    if (statusCondicaoFluxo === CondicoesEspeciaisStatus.Contraproposta) {
      operacaoProposta = 'aprovarContraproposta';
    } else if (
      statusCondicaoFluxo === CondicoesEspeciaisStatus.PendenteDiretoria
      && temCaracteristicaContraproposta
      && houveAlteracaoParaContraproposta
    ) {
      operacaoProposta = 'enviarContraproposta';
    } else {
      operacaoProposta = 'aprovarProposta';
    }
  }
  var podeExecutarAcao = isModoProposta
    ? !isGerenteVendoPendenteDiretoria && !isUsuarioSemAcaoContraproposta
    : podeGerarVenda;
  var isDiretoriaEditandoContraproposta = isModoProposta
    && statusCondicaoFluxo === CondicoesEspeciaisStatus.PendenteDiretoria
    && temCaracteristicaContraproposta;
  var isModoPropostaSomenteLeitura = isModoProposta && !isDiretoriaEditandoContraproposta;
  var textoBotaoAcao = 'Gerar Venda';
  if (operacaoProposta === 'aprovarProposta') textoBotaoAcao = 'Analisar Solicitação';
  if (operacaoProposta === 'enviarContraproposta') textoBotaoAcao = 'Enviar Contraproposta';
  if (operacaoProposta === 'aprovarContraproposta') textoBotaoAcao = 'Analisar Contraproposta';

  // W-0075 (devolução SINAL pt.1): gera a Proposta REAL (mesmo PDF do CRM) a partir
  // da simulação, SEM gravar a venda e SEM cliente (bloco de cliente em branco).
  // Monta o mesmo payload da venda (com contextoVenda sintético — só a família, sem
  // prospecto) e chama o endpoint que reusa o PropostaVendaPdfBuilder no backend.
  var handleImprimirProposta = useCallback(function() {
    if (!podeExportarResumo) return Promise.resolve();
    if (!contextoSelecao || !contextoSelecao.codigoFamilia) {
      toast.warn('Selecione um empreendimento e um lote antes de imprimir a proposta.');
      return Promise.resolve();
    }
    // Abre a janela já no clique (evita bloqueio de pop-up); a URL do PDF chega depois.
    var win = window.open('', '_blank');

    var payload = simulatorStateToPropostaPayload({
      codigoFamilia: contextoSelecao.codigoFamilia,
      dados: dados,
      codigoAtivo: codigoAtivo,
      dataBase: dataBase,
      isSac: isSAC,
      financiamentoPlano: financiamentoAtivo,
      vencimentoFinanciamento: vencimentoFinanciamento,
      pagamentosIncorp: pagamentosIncorp,
      pagamentosMesa: pagamentosMesa,
      parcelasEmSeries: parcelasEmSeries,
      parcelasIntermediariasManuais: parcelasIntermediariasManuais,
      condicionantesAplicadas: condicionantesAplicadas,
      condicoesAplicadas: condicoesAplicadasFluxo,
    });

    return gerarPropostaSimuladorPdf(payload)
      .then(function(res) {
        var url = res && res.url ? res.url : null;
        if (!url) throw new Error('URL da proposta não retornada');
        if (win) win.location = url;
        else window.open(url, '_blank');
      })
      .catch(function(err) {
        if (win) { try { win.close(); } catch (e) { /* ignore */ } }
        var msg = (err && err.message) ? err.message : 'Falha ao gerar a proposta';
        toast.error('Erro ao gerar proposta: ' + msg);
      });
  }, [
    podeExportarResumo, contextoSelecao, dados, codigoAtivo, dataBase, isSAC,
    financiamentoAtivo, vencimentoFinanciamento, pagamentosIncorp, pagamentosMesa,
    parcelasEmSeries, parcelasIntermediariasManuais, condicionantesAplicadas,
    condicoesAplicadasFluxo,
  ]);

  if (!codigoAtivo && carregandoProposta) {
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Carregando proposta...</p>
      </div>
    );
  }

  if (!codigoAtivo && erroProposta) {
    return <Alert variant="danger">{erroProposta}</Alert>;
  }

  if (!codigoAtivo) return null;

  return (
    <>
      {isLoading && !dados && (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Carregando simulação...</p>
        </div>
      )}

      {!dados && !isLoading && (
        <p className="text-muted">Nenhum dado encontrado para este ativo.</p>
      )}

      {dados && (
        <>
          {isModoProposta && (
            <Alert variant={operacaoProposta === 'enviarContraproposta' ? 'warning' : 'info'} className="py-2">
              <strong>Proposta #{codigoProposta}</strong>{' '}
              {operacaoProposta === 'enviarContraproposta'
                ? 'com alterações para envio de contraproposta.'
                : operacaoProposta === 'aprovarContraproposta'
                  ? 'em contraproposta.'
                  : 'carregada para revisão/aprovação.'}
            </Alert>
          )}
          {!isModoProposta && !dados.ativo_disponivel && <AvisoIndisponivel />}

          {isModoPropostaSomenteLeitura && (
            <Alert variant="secondary" className="py-2">
              Esta proposta está em modo de revisão. As condições da venda ficam bloqueadas; use a ação final para aprovar ou recusar.
            </Alert>
          )}

          <div style={isModoPropostaSomenteLeitura ? { pointerEvents: 'none', opacity: 0.72 } : undefined}>
          <ResumoAtivo
            dados={dados}
            saldoFinanciarLiquido={saldoFinanciarLiquido}
            valorVendaEditado={valorVendaEditado}
            onValorVendaChange={handleValorVendaChange}
            dataVenda={dataBase}
            onDataVendaChange={handleDataBaseChange}
            condicoesAtivas={!!condicoesAplicadasFluxo}
            tabelaOptions={tabelaOptions}
            tabelaSelecionada={tabelaSelecionada}
            onTrocarTabela={handleTrocarTabela}
            isLoading={isLoading}
          />

          {/* Condições Especiais + Pagamento do Sinal lado a lado.
              Lado a lado SOMENTE em lg+ — abaixo disso empilha, senão o sinal-split
              (que ainda divide em 2 cards) fica com ~33% da tela e estoura com cheques.
              minWidth: 0 essencial para flex + grid não estourar.
              no-gutters: Row aninhada herda mx:-15px do Bootstrap — somado com Row
              externa, empurra além da viewport. */}
          <Row className="mb-0 align-items-stretch no-gutters">
            <Col lg={4} xs={12} className="pr-lg-1 d-flex flex-column" style={{ minWidth: 0 }}>
              <CondicoesEspeciaisCompleto
                valorVendaOriginal={dados.valor_a_vista || 0}
                condicoesAplicadas={condicoesAplicadasFluxo}
                onAplicar={handleAplicarCondicoes}
                onRemover={handleRemoverCondicoes}
                resetSignal={resetCounter}
                dataBase={dataBase}
              />
            </Col>
            <Col lg={8} xs={12} className="pl-lg-1 d-flex flex-column" style={{ minWidth: 0 }}>
              {(function() {
                var requerSplitSinal = dados.tipo_recebimento_comissao === TipoComissao.RetidaCorretor;
                var ratioVV = (dados.valor_a_vista > 0) ? valorVendaEditado / dados.valor_a_vista : 1;
                var totalIncorp = requerSplitSinal
                  ? Math.round((dados.entrada_incorporadora || 0) * ratioVV * 100) / 100
                  : valorEntradaEfetiva;
                var totalMesa = requerSplitSinal
                  ? Math.round((dados.entrada_imobiliaria || 0) * ratioVV * 100) / 100
                  : 0;
                var subtituloUnico = (function() {
                  var parts = [];
                  if (dados.sinal_minimo > 0) {
                    parts.push('Entrada mínima: R$ ' + formatCurrency(dados.sinal_minimo));
                  }
                  return parts.length > 0 ? parts.join(' · ') : null;
                })();
                return (
                  <PagamentosSinalSplit
                    empreendimento={{ tipo_recebimento_comissao: dados.tipo_recebimento_comissao || 0 }}
                    pagamentosIncorp={pagamentosIncorp}
                    setPagamentosIncorp={handlePagamentosIncorpChange}
                    pagamentosMesa={pagamentosMesa}
                    setPagamentosMesa={handlePagamentosMesaChange}
                    totalRequeridoIncorp={totalIncorp}
                    totalRequeridoMesa={totalMesa}
                    cartoes={cartoes}
                    subtitulo={subtituloUnico}
                  />
                );
              })()}
            </Col>
          </Row>

          {/* Divisão de Comissão — só RetidaCorretor.
              Espelha venda real (Sinal/index.js:1120 + ModalDivisaoComissao): botão abre modal,
              save commita ao state, resumo mostra na tela com opções editar/remover. */}
          {dados.tipo_recebimento_comissao === TipoComissao.RetidaCorretor && (
            <Card className="mb-2">
              <Card.Body className="py-2">
                <h6 className="mb-2 text-primary"><strong>Divisão de Comissão</strong></h6>
                {divisaoComissao.codigoUsuario ? (
                  <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center" style={{ gap: 8 }}>
                    {(function() {
                      const corretor = corretores.find(c => c.codigo === divisaoComissao.codigoUsuario);
                      const nome = corretor
                        ? (corretor.nome || corretor.nome_completo || 'Usuário ' + corretor.codigo)
                        : 'Usuário ' + divisaoComissao.codigoUsuario;
                      return (
                        <div className="flex-grow-1 small" style={{ minWidth: 0 }}>
                          Corretor: <strong>{nome}</strong>
                          <span className="text-muted ml-2">
                            ({Number(divisaoComissao.porcentagem || 0).toFixed(2).replace('.', ',')}%)
                          </span>
                        </div>
                      );
                    })()}
                    <div className="d-flex flex-shrink-0" style={{ gap: 4 }}>
                      <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => setDivisaoModalAberta({
                          codigo: codigoAtivo,
                          quadra: dados.mapa1,
                          lote: dados.mapa2,
                          codigo_usuario: divisaoComissao.codigoUsuario,
                          porcentagem: divisaoComissao.porcentagem,
                        })}
                        title="Editar divisão"
                      >
                        <FaPencilAlt />
                        <span className="d-none d-md-inline ml-1">Editar</span>
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => {
                          marcarAlteracaoProposta();
                          setDivisaoComissao({ codigoUsuario: null, porcentagem: '' });
                        }}
                        title="Remover divisão"
                      >
                        <FaTrash />
                        <span className="d-none d-md-inline ml-1">Remover</span>
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center" style={{ gap: 8 }}>
                    <small className="text-muted flex-grow-1 mb-2 mb-sm-0">
                      Nenhuma divisão definida — comissão integral do corretor logado.
                    </small>
                    <Button
                      size="sm"
                      variant="outline-primary"
                      className="flex-shrink-0"
                      onClick={() => setDivisaoModalAberta({
                        codigo: codigoAtivo,
                        quadra: dados.mapa1,
                        lote: dados.mapa2,
                        codigo_usuario: null,
                        porcentagem: '',
                      })}
                    >
                      <FaPlus className="mr-1" />
                      Dividir comissão
                    </Button>
                  </div>
                )}
              </Card.Body>
            </Card>
          )}

          {/* Condicionantes — mesmo guard da venda real: mostra se existem registros
              configurados, independente de balaoAte */}
          {dados.intermediarias_configuradas && dados.intermediarias_configuradas.length > 0 && (
            <ParcelasCondicionantes
              intermediariasConfig={dados.intermediarias_configuradas}
              valorVenda={valorVendaEditado}
              taxaPI={Number(dados.taxa_parcela_intermediaria || 0)}
              saldoFinanciarBase={saldoFinanciarBase}
              calcularValorFuturo={calcularValorFuturo}
              dataVenda={dataBase}
              onChange={handleCondicionantesChange}
              onLinhasAplicadas={handleCondicionantesLinhasChange}
              bloqueado={parcelasIntermediariasManuais.length > 0}
              mensagemBloqueio="Existem parcelas intermediárias adicionadas. Remova-as antes de aplicar condicionantes (mesma regra da venda real)."
              resetSignal={resetCounter}
            />
          )}

          {/* Intermediárias manuais — guard igual à venda real: habilita_intermediarias
              (balaoAte no futuro), separado das condicionantes */}
          {dados.habilita_intermediarias && (
            <ParcelasIntermediariasManual
              parcelas={parcelasIntermediariasManuais}
              setParcelas={handleParcelasIntermediariasChange}
              taxaPI={Number(dados.taxa_parcela_intermediaria || 0)}
              dataVenda={dataBase}
              isParcelasNaoConcomitantes={isParcelasNaoConcomitantes}
              setIsParcelasNaoConcomitantes={handleParcelasNaoConcomitantesChange}
              resetSignal={resetCounter}
            />
          )}

          {/* Parcelas Escadinha */}
          {exibeParcelasProgramadas && (
            <Card className="mb-2">
              <Card.Body className="py-2">
                <h6 className="mb-2 text-primary"><strong>Parcelas Programadas</strong></h6>
                <div className="small text-muted mb-2">
                  {dados.ativo_escadinha.quantidade_de_series} séries ×{' '}
                  {dados.ativo_escadinha.parcelas_por_serie} parcelas ·{' '}
                  1ª série R$ {formatCurrency(dados.ativo_escadinha.parcela_inicial)} ·{' '}
                  Degrau R$ {formatCurrency(dados.ativo_escadinha.degrau)}
                </div>
                <Row className="align-items-center">
                  <Col xs={12} sm={4} md={3}>
                    <Form.Group className="mb-2 mb-sm-0">
                      <Form.Label className="small mb-1">Dia de vencimento</Form.Label>
                      <Form.Control
                        as="select"
                        size="sm"
                        value={diaVencimentoProgramadas}
                        onChange={function(e) {
                          setDiaVencimentoProgramadas(Number(e.target.value));
                          if (parcelasEmSeries.length > 0) handleParcelasProgramadasChange([]);
                        }}
                      >
                        {DIAS_VENCIMENTO_PROGRAMADAS.map(function(dia) {
                          return (
                            <option key={dia} value={dia}>
                              {String(dia).padStart(2, '0')}
                            </option>
                          );
                        })}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={5} md="auto">
                    <Button
                      size="sm"
                      variant={parcelasEmSeries.length > 0 ? 'outline-danger' : 'outline-primary'}
                      className="mb-2 mb-sm-0"
                      onClick={parcelasEmSeries.length > 0
                        ? function() { handleParcelasProgramadasChange([]); }
                        : handleGerarEscadinha
                      }
                    >
                      {parcelasEmSeries.length > 0 ? 'Remover Parcelas Programadas' : 'Gerar Parcelas Programadas'}
                    </Button>
                  </Col>
                  {parcelasEmSeries.length > 0 && (
                    <Col xs={12} sm md className="text-sm-right">
                      <div className="small text-muted">
                        {parcelasEmSeries.length} parcelas · VP Total: R$ {formatCurrency(totalEscadinhaVP)}
                      </div>
                    </Col>
                  )}
                </Row>

                {parcelasEmSeries.length > 0 && (
                  <div className="border rounded mt-2">
                    {gruposEscadinha.map(function(g, i) {
                      const intervalo = g.qtd === 1
                        ? formatDate(g.inicio)
                        : formatDate(g.inicio) + ' → ' + formatDate(g.fim);
                      return (
                        <div
                          key={[
                            'esc-grupo',
                            g.valor || '',
                            g.inicio || '',
                            g.fim || '',
                            g.qtd || '',
                          ].join('-')}
                          className="d-flex justify-content-between align-items-start px-2 py-1 small"
                          style={{ borderBottom: i + 1 === gruposEscadinha.length ? 0 : '1px solid #f0f0f0' }}
                        >
                          <div>
                            <strong>Série {i + 1}</strong>
                            {' · '}
                            {g.qtd > 1 && <strong>{g.qtd}x </strong>}
                            VF <strong>R$ {formatCurrency(g.valor)}</strong>
                            {' · '}VP{' '}
                            <span className="text-muted">
                              R$ {formatCurrency(g.qtd > 1 ? g.vpTotal : g.valorPresente)}
                            </span>
                          </div>
                          <div className="text-right text-muted ml-3" style={{ whiteSpace: 'nowrap' }}>
                            {intervalo}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </Card.Body>
            </Card>
          )}

          {/* Plano de Financiamento */}
          <Card className="mb-2">
            <Card.Body className="py-2">
              <h6 className="mb-2 text-primary"><strong>Plano de Financiamento</strong></h6>

              {/* Breakdown saldo — Row sem flex-nowrap (deixa quebrar para 2 linhas em
                  telas estreitas). Cada Col é xs={6} sm={4} md=auto: em mobile 2 por linha,
                  em sm 3 por linha, em md+ todas na mesma linha. Evita overflow quando
                  o sinal cobre tudo e mais Cols ficam visíveis (VV + Sinal + Cond +
                  Interm + Esc + Saldo = 6 colunas potenciais). */}
              <div className="rounded p-2 mb-2" style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}>
                <Row className="align-items-center text-center no-gutters">
                  <Col xs={6} sm={4} md className="px-1">
                    <small className="text-muted d-block">Valor de Venda</small>
                    <span>R$ {formatCurrency(valorVendaEditado)}</span>
                  </Col>
                  {totalTitulosSinal > 0 && (
                    <Col xs={6} sm={4} md className="px-1">
                      <small className="text-muted d-block">Sinal</small>
                      <span>R$ {formatCurrency(totalTitulosSinal)}</span>
                    </Col>
                  )}
                  {deducaoCondicionantes > 0 && (
                    <Col xs={6} sm={4} md className="px-1">
                      <small className="text-muted d-block">Condicionantes</small>
                      <span>R$ {formatCurrency(deducaoCondicionantes)}</span>
                    </Col>
                  )}
                  {totalIntermediariasManuaisVP > 0 && (
                    <Col xs={6} sm={4} md className="px-1">
                      <small className="text-muted d-block">Intermediárias</small>
                      <span>R$ {formatCurrency(totalIntermediariasManuaisVP)}</span>
                    </Col>
                  )}
                  {totalEscadinhaVP > 0 && (
                    <Col xs={6} sm={4} md className="px-1">
                      <small className="text-muted d-block">Programadas</small>
                      <span>R$ {formatCurrency(totalEscadinhaVP)}</span>
                    </Col>
                  )}
                  <Col xs={6} sm={4} md className="px-1">
                    <small className="text-muted d-block">Saldo a Financiar</small>
                    <strong className="text-success">R$ {formatCurrency(saldoFinanciarLiquido)}</strong>
                  </Col>
                </Row>
              </div>

              <Row className="align-items-end">
                <Col md={4} xs={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small mb-1">Plano de Parcelamento</Form.Label>
                    <Select
                      placeholder="Selecione o plano..."
                      options={planoOptions}
                      value={planoSelecionado}
                      onChange={handlePlanoChange}
                      styles={selectStyles}
                      components={{ DropdownIndicator: DropdownIndicator }}
                      isClearable
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </Form.Group>
                </Col>
                <Col md={3} xs={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="small mb-1 d-flex justify-content-between">
                      <span>Vencimento 1ª parcela</span>
                      {vencimentoFinanciamentoManual && (
                        <a
                          href="#"
                          className="text-muted small"
                          onClick={function(e) {
                            e.preventDefault();
                            marcarAlteracaoProposta();
                            setVencimentoFinanciamentoManual(false);
                            // useEffect vai recalcular
                          }}
                          title="Voltar ao cálculo automático (último sinal + carência + 1 mês)"
                        >
                          ↺ auto
                        </a>
                      )}
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      type="date"
                      value={vencimentoFinanciamento}
                      min={temCarenciaCondicaoEspecial ? vencimentoMinimoCarencia : undefined}
                      onChange={function(e) {
                        marcarAlteracaoProposta();
                        setVencimentoFinanciamento(e.target.value);
                        setVencimentoFinanciamentoManual(true);
                      }}
                      isInvalid={!!vencimentoFinanciamentoAntesCarencia}
                    />
                    {vencimentoFinanciamentoAntesCarencia && (
                      <Form.Control.Feedback type="invalid">
                        Mínimo pela carência: {formatDate(vencimentoMinimoCarencia)}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                {planoSelecionado && planoSelecionado.custom && (
                  <Col md={3} xs={12}>
                    <Form.Group className="mb-2">
                      <Form.Label className="small mb-1">
                        Qtd. de parcelas
                        {dados && dados.qtd_max_parcelas && (
                          <span className="text-muted ml-1">(máx. {dados.qtd_max_parcelas})</span>
                        )}
                      </Form.Label>
                      <Form.Control
                        size="sm"
                        type="number"
                        min="1"
                        max={dados && dados.qtd_max_parcelas ? dados.qtd_max_parcelas : undefined}
                        placeholder="Ex.: 48"
                        value={qtdPersonalizada}
                        onChange={function(e) {
                          marcarAlteracaoProposta();
                          setQtdPersonalizada(e.target.value);
                        }}
                        isInvalid={
                          !!(dados && dados.qtd_max_parcelas
                            && qtdPersonalizada
                            && parseInt(qtdPersonalizada, 10) > dados.qtd_max_parcelas)
                        }
                        autoFocus
                      />
                      {dados && dados.qtd_max_parcelas
                        && qtdPersonalizada
                        && parseInt(qtdPersonalizada, 10) > dados.qtd_max_parcelas && (
                          <Form.Text className="text-danger">
                            Quantidade máxima excedida
                          </Form.Text>
                        )}
                    </Form.Group>
                  </Col>
                )}
                {financiamentoPlano && financiamentoPlano.qtd > 0 && !resultado && (
                  <Col md={3} xs={12}>
                    <div className="rounded p-2 mb-2" style={{ background: '#e8f5e9', border: '1px solid #c8e6c9' }}>
                      <small className="text-muted d-block text-center">{financiamentoPlano.qtd}x de</small>
                      <div className="text-center">
                        <strong>R$ {formatCurrency(financiamentoPlano.valorParcela)}</strong>
                        <small className="text-muted"> /mês</small>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>

          {/* Simulação Inversa — temporariamente desabilitada (não está em uso).
              Quando habilitar de novo, restaurar o Card + Collapse com FormularioSimulacao
              e o <ResultadoSimulacao resultado={resultado} /> abaixo. */}

          <TabelaSAC tabela={tabelaAmortizacao} tipo={isSAC ? 'SAC' : 'PRICE'} />
          <PainelAntecipacao
            antecipacao={antecipacao}
            onSimular={handleSimularAntecipacao}
            onSimularPorValor={handleSimularAntecipacaoPorValor}
            onLimpar={() => setResultadoAntecipacao(null)}
            resultado={resultadoAntecipacao}
          />
          </div>

          {/* Resumo Final — fica APÓS a antecipação para que ela participe do print/copy. */}
          <ResumoVenda
            valorVenda={valorVendaEditado}
            valorVendaOriginal={dados ? dados.valor_a_vista : 0}
            periodicidadeAplicacao={periodicidadeAplicacaoTabela}
            pagamentosSinal={pagamentosIncorp.concat(pagamentosMesa).map(function(p, i) {
              var labelByCodigo = {
                1: 'Boleto', 2: 'Cheque', 3: 'Dinheiro', 4: 'Cartão', 5: 'Depósito/PIX',
              };
              var label = labelByCodigo[p.tipo_parcela] || ('Tipo ' + p.tipo_parcela);
              return {
                id: 'sn-' + i + '-' + p.tipo_parcela,
                tipo: label,
                tipoLabel: label,
                qtdParcelas: 1,
                valor: p.valor,
                vencimento: p.vencimento,
                emitente: p.emitente || null,
                banco: p.banco || null,
                agencia: p.agencia || null,
                numero: p.numero || null,
              };
            })}
            condicionantes={condicionantesAplicadas}
            intermediarias={parcelasIntermediariasManuais}
            escadinha={parcelasEmSeries}
            financiamento={financiamentoAtivo}
            saldoFinanciado={saldoFinanciarProjetado}
            condicoesEspeciais={condicoesAplicadasFluxo}
            dataBase={dataBase}
            vencimentoFinanciamento={vencimentoFinanciamento}
            tabelaAmortizacao={tabelaAmortizacao}
            tipoFinanciamento={isSAC ? 'SAC' : 'PRICE'}
            antecipacao={antecipacao}
            resultadoAntecipacao={resultadoAntecipacao}
            podeExportar={podeExportarResumo}
            errosExportar={errosResumoExportar}
            onImprimirProposta={handleImprimirProposta}
            loteDescricao={dados ? (
              (dados.mapa1 || '') + (dados.mapa2 ? ' / ' + dados.mapa2 : '')
            ) : ''}
            empreendimentoNome={
              (contextoSelecao && contextoSelecao.empreendimento && contextoSelecao.empreendimento.nome)
              || (dados && dados.empreendimento_nome)
              || ''
            }
          />

          {/* Botão Gerar Venda — final de tudo. Mostra sempre que houver lote
              selecionado; desabilita se faltar plano de financiamento. Antes de abrir
              o modal, valida o que dá pra validar com o state da página — assim erros
              aparecem aqui em vez de só depois de preencher o prospecto no modal. */}
          {contextoSelecao && contextoSelecao.codigoFamilia && (
            <div className="text-center my-4">
              <Button
                size="lg"
                variant="success"
                onClick={function() {
                  var erros = validarPayloadAntesAbrirModal({
                    dados: dados,
                    codigoAtivo: codigoAtivo,
                    codigoFamilia: contextoSelecao && contextoSelecao.codigoFamilia,
                    valorVendaEditado: valorVendaEditado,
                    dataBase: dataBase,
                    financiamentoPlano: financiamentoAtivo,
                    vencimentoFinanciamento: vencimentoFinanciamento,
                    saldoFinanciarLiquido: saldoFinanciarProjetado,
                    pagamentosIncorp: pagamentosIncorp,
                    pagamentosMesa: pagamentosMesa,
                    parcelasEmSeries: parcelasEmSeries,
                    parcelasIntermediariasManuais: parcelasIntermediariasManuais,
                    condicionantesAplicadas: condicionantesAplicadas,
                    condicoesAplicadas: condicoesAplicadasFluxo,
                    isParcelasNaoConcomitantes: isParcelasNaoConcomitantes,
                    divisaoComissao: divisaoComissao,
                    codigoProposta: codigoProposta,
                    contraproposta: operacaoProposta === 'enviarContraproposta',
                  });
                  if (erros.length > 0) {
                    setErrosPagina(erros);
                    return;
                  }
                  setErrosPagina([]);
                  setShowModalGerarVenda(true);
                }}
                disabled={
                  financiamentoAtivo === null
                  || (!isModoProposta && dados && !dados.ativo_disponivel)
                  || !podeExecutarAcao
                }
                title={
                  !podeExecutarAcao
                    ? (isModoProposta ? 'Proposta disponível apenas para consulta neste perfil' : 'Usuário sem permissão para gerar venda (precisa ser corretor ou ADM com característica 673)')
                    : !isModoProposta && dados && !dados.ativo_disponivel
                      ? 'Lote indisponível - não é possível gerar venda'
                      : financiamentoAtivo === null
                        ? 'Selecione um plano de financiamento antes de continuar'
                        : 'Abrir formulário da proposta'
                }
              >
                {textoBotaoAcao}
              </Button>
              {!podeExecutarAcao && (
                <div className="text-muted small mt-1">
                  {isModoProposta
                    ? 'Esta proposta fica disponível apenas para consulta neste perfil.'
                    : 'Apenas corretores ou administradores autorizados podem gerar venda.'}
                </div>
              )}
              {!isModoProposta && dados && !dados.ativo_disponivel && (
                <div className="text-danger small mt-1">
                  Lote indisponível - não é possível gerar venda neste lote.
                </div>
              )}
              {errosPagina.length > 0 && (
                <div className="mt-2 mx-auto" style={{ maxWidth: 720 }}>
                  <div className="alert alert-danger text-left py-2 mb-0 small">
                    <strong>Corrija antes de continuar:</strong>
                    <ul className="mb-0 mt-1">
                      {errosPagina.map(function(e) {
                        return (
                          <li key={'erro-pagina-' + String(e || '').replace(/[^a-zA-Z0-9]+/g, '-').slice(0, 80)}>
                            {e}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              )}
              {financiamentoAtivo === null && dados && (isModoProposta || dados.ativo_disponivel) && (
                <div className="text-muted small mt-1">
                  Selecione um plano de financiamento para habilitar.
                </div>
              )}
            </div>
          )}

          <ModalGerarVenda
            show={showModalGerarVenda}
            sinalParcial={sinalParcial}
            onCancel={function() { setShowModalGerarVenda(false); }}
            onVendaGravadaFechar={function() {
              setShowModalGerarVenda(false);
              onVendaGravadaFechar();
            }}
            contextoSelecao={contextoSelecao}
            cartoes={cartoes}
            corretorAtivo={corretorAtivo}
            setCorretorAtivo={setCorretorAtivo}
            opcoesCorretores={opcoesCorretores}
            modoCorretor={modoCorretor}
            podeGerarVenda={podeExecutarAcao}
            codigoProposta={codigoProposta}
            operacaoProposta={operacaoProposta}
            propostaGravada={propostaAuxiliar && propostaAuxiliar.gravada}
            contextoProposta={contextoContraproposta}
            simulatorState={{
              dados: dados,
              codigoAtivo: codigoAtivo,
              valorVendaEditado: valorVendaEditado,
              dataBase: dataBase,
              financiamentoPlano: financiamentoAtivo,
              vencimentoFinanciamento: vencimentoFinanciamento,
              saldoFinanciarLiquido: saldoFinanciarProjetado,
              pagamentosIncorp: pagamentosIncorp,
              pagamentosMesa: pagamentosMesa,
              parcelasEmSeries: parcelasEmSeries,
              parcelasIntermediariasManuais: parcelasIntermediariasManuais,
              condicionantesAplicadas: condicionantesAplicadas,
              condicoesAplicadas: condicoesAplicadasFluxo,
              isParcelasNaoConcomitantes: isParcelasNaoConcomitantes,
              divisaoComissao: divisaoComissao,
              codigoProposta: codigoProposta,
              contraproposta: operacaoProposta === 'enviarContraproposta',
            }}
          />

          <ModalDivisaoComissao
            divisao={divisaoModalAberta}
            onCancel={() => setDivisaoModalAberta(null)}
            corretores={corretores}
            readonly={false}
            salvarDivisaoComissao={(values) => {
              // values: { codigo_usuario, porcentagem, codigo } vindos do Formik do modal.
              // Limpar tudo se ambos vierem vazios (usuário deixou em branco no modal).
              if (!values.codigo_usuario && !values.porcentagem) {
                marcarAlteracaoProposta();
                setDivisaoComissao({ codigoUsuario: null, porcentagem: '' });
                return;
              }
              marcarAlteracaoProposta();
              setDivisaoComissao({
                codigoUsuario: values.codigo_usuario,
                porcentagem: values.porcentagem,
              });
            }}
          />
        </>
      )}
    </>
  );
}

export default function SimuladorFinanceiro(props) {
  var isModal = props.show !== undefined;

  if (isModal) {
    // Modo modal (aberto pelo Mapa): só temos codigoAtivo + codigoFamilia. O
    // contextoSelecao precisa ser preenchido pra que o botão "Gerar Venda" apareça
    // (condicional em contextoSelecao.codigoFamilia no ConteudoSimulador). Quadra/Lote
    // são derivados de dados.mapa1/mapa2 dentro do próprio ConteudoSimulador — não
    // precisa estar aqui.
    var contextoModal = props.codigoFamilia
      ? {
          codigoFamilia: props.codigoFamilia,
          empreendimentoLabel: props.empreendimentoLabel || '',
        }
      : null;
    return (
      <Modal show={props.show} onHide={props.onHide} centered size="xl" scrollable>
        <Modal.Header closeButton style={{ backgroundColor: '#0747a6' }}>
          <Modal.Title style={{ color: '#FFFFFF' }}>Simulador Financeiro</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowX: 'hidden' }}>
          {props.show && (
            <ConteudoSimulador
              codigoAtivo={props.codigoAtivo}
              contextoSelecao={contextoModal}
              onVendaGravadaFechar={props.onHide}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.onHide}>Fechar</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return <SimuladorFinanceiroPagina {...props} />;
}

function SimuladorFinanceiroPagina(props) {
  var queryString = qs.parse((props.location && props.location.search) || '', {
    ignoreQueryPrefix: true,
  });
  var codigoProposta = queryString.codigoProposta || null;
  const [codigoAtivoSelecionado, setCodigoAtivoSelecionado] = useState(null);
  const [contextoSelecao, setContextoSelecao] = useState(null);
  // Incrementa pra forçar remount do SelecaoAtivo + ConteudoSimulador depois de gravar
  // a venda — limpa qualquer state interno dos componentes (selects, modais, dados).
  const [chaveReset, setChaveReset] = useState(0);

  const resetarTudo = useCallback(() => {
    setCodigoAtivoSelecionado(null);
    setContextoSelecao(null);
    setChaveReset((k) => k + 1);
  }, []);

  return (
    <Container fluid className="py-3" style={{ overflowX: 'hidden' }}>
      <h5 className="mb-2">
        {codigoProposta ? 'Simulador Financeiro - Proposta #' + codigoProposta : 'Simulador Financeiro'}
      </h5>
      {!codigoProposta && (
        <SelecaoAtivo
          key={'selecao-' + chaveReset}
          onSelectAtivo={setCodigoAtivoSelecionado}
          onContextoChange={setContextoSelecao}
        />
      )}
      <ConteudoSimulador
        key={'conteudo-' + chaveReset + '-' + (codigoProposta || 'novo')}
        codigoAtivo={codigoAtivoSelecionado}
        contextoSelecao={contextoSelecao}
        onVendaGravadaFechar={resetarTudo}
        codigoProposta={codigoProposta}
      />
    </Container>
  );
}
